import { combineReducers, applyMiddleware, createStore } from 'redux';
import 'redux-logger';
import { ofType, combineEpics, createEpicMiddleware } from 'redux-observable';
import { get, isEqual, find, omit, reduce, has, map as map$1, zipObject, size, split, forEach, filter, merge as merge$1, camelCase, capitalize, some, isArray as isArray$1, isFunction as isFunction$1, cloneDeep, set, remove, sortBy, keys, values } from 'lodash';
import * as xmpp from '@nextiva/chat-js-client';
import { xml } from '@nextiva/chat-js-client';
import axios from 'axios';
import { from as from$1, merge, of as of$1, concat, fromEventPattern } from 'rxjs';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import uuid from 'uuid-random';
import { handleActions } from 'redux-actions';

var DeprecatedToActualZones = {
  'US/Alaska': 'America/Anchorage',
  'US/Aleutian': 'America/Adak',
  'US/Arizona': 'America/Phoenix',
  'US/Central': 'America/Chicago',
  'US/Eastern': 'America/New_York',
  'US/East-Indiana': 'America/Indiana/Indianapolis',
  'US/Hawaii': 'Pacific/Honolulu',
  'US/Indiana-Starke': 'America/Indiana/Knox',
  'US/Michigan': 'America/Detroit',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Pacific-New': 'America/Los_Angeles',
  'US/Samoa': 'Pacific/Pago_Pago',
  UCT: 'Etc/UCT',
  Universal: 'Etc/UTC',
  UTC: 'Etc/UTC',
  Zulu: 'Etc/UTC'
};

var validateTimezone = (function (timezone) {
  return get(DeprecatedToActualZones, timezone, timezone);
});

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var defaultBaseUrl = process.env.REACT_APP_BASE_URL || ''; // Time for invitation reject countdown

var defaultConfig = {
  baseURL: defaultBaseUrl
};
var request = (function (url, config) {
  return from$1(axios(_objectSpread2({}, defaultConfig, {}, config, {
    url: url
  })));
});

var createSelector = createSelectorCreator(defaultMemoize, isEqual);

var parseXML = (function (data) {
  var p = new xml.Parser();
  var result = null;
  var error = null;
  p.on('start', function (el) {
    result = el;
  });
  p.on('element', function (el) {
    result.append(el);
  });
  p.on('error', function (err) {
    error = err;
  });
  p.write(data);
  p.end();

  if (error) {
    throw error;
  } else {
    return result;
  }
});

var getDomain = function getDomain() {
  return /localhost|local.*cospace/gi.test(window.location.hostname) ? 'nextiva.com' : 'chat-ejabberd-sd';
};

var getUtcIsoTimestamp = function getUtcIsoTimestamp(timestamp) {
  var utcIsoString = '';

  if (!timestamp) {
    utcIsoString = new Date().toISOString();
  } else if (typeof timestamp === 'string') {
    utcIsoString = timestamp;
  } else if (_typeof(timestamp) === 'object') {
    utcIsoString = timestamp.toISOString();
  }

  return utcIsoString.replace('Z', '+00:00');
};

var Types = {
  form: 'form',
  formResult: 'form_result',
  formResponse: 'form_response',
  formError: 'form_error',
  initChat: 'init_chat',
  releaseChat: 'release_chat',
  workingHours: 'working_hours',
  roomInvitation: 'room_invitation',
  invitationDeclined: 'invitation_declined',
  newParticipant: 'new_participant',
  removedParticipant: 'removed_participant',
  chatEnded: 'chat_ended',
  system: 'system',
  transferInitialized: 'transfer_initialized',
  transferExpired: 'transfer_expired',
  transferAccepted: 'transfer_accepted',
  transferDeclined: 'transfer_declined',
  transferInit: 'transfer_init',
  schedule: 'schedule'
};

var routing = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Types: Types
});

var transformFormResult = function transformFormResult(messages) {
  var formResult = find(messages, function (message) {
    return get(message, ['body', 'payload', 'type']) === Types.formResult;
  });

  var _get = get(formResult, ['body', 'payload'], {}),
      type = _get.type,
      fields = _get.fields;

  var timestamp = get(formResult, 'created_at', getUtcIsoTimestamp());
  return {
    payload: {
      type: type,
      content: {
        fields: fields
      }
    },
    meta: {
      timestamp: timestamp
    }
  };
};

var getMessage = function getMessage(content) {
  var message = get(content, ['body', 'text']);
  if (message) return message;
  var data = get(content, ['body', 'payload', 'data']);
  if (data) return data;
  return get(content, ['body', 'payload', 'info'], {});
};

var transformMessage = function transformMessage(content) {
  var type = get(content, ['body', 'payload', 'type']);
  var timestamp = get(content, 'created_at', '');
  var meta = omit(content, ['created_at', 'body']);
  return {
    meta: meta,
    timestamp: timestamp,
    type: type,
    message: getMessage(content)
  };
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + required > 1 ? 's' : '' + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);
  return formatted[formatted.length - 1].value;
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : '';
} // If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.


function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  }

  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length
  });
}

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date);
  var filled = [];

  for (var i = 0; i < formatted.length; i++) {
    var pos = typeToPos[formatted[i].type];

    if (pos >= 0) {
      filled[pos] = parseInt(formatted[i].value, 10);
    }
  }

  return filled;
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted); // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]

  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
} // Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.


var dtfCache = {};

function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    dtfCache[timeZone] = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  return dtfCache[timeZone];
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
  timezoneIANA: /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
}; // Parse various time zone offset formats to an offset in milliseconds

function tzParseTimezone(timezoneString, date) {
  var token;
  var absoluteOffset; // Z

  token = patterns.timezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  }

  var hours; // ±hh

  token = patterns.timezoneHH.exec(timezoneString);

  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone$1()) {
      return NaN;
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  } // ±hh:mm or ±hhmm


  token = patterns.timezoneHHMM.exec(timezoneString);

  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone$1(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset;
  } // IANA time zone


  token = patterns.timezoneIANA.exec(timezoneString);

  if (token) {
    // var [fYear, fMonth, fDay, fHour, fMinute, fSecond] = tzTokenizeDate(date, timezoneString)
    var tokens = tzTokenizeDate(date, timezoneString);
    var asUTC = Date.UTC(tokens[0], tokens[1] - 1, tokens[2], tokens[3], tokens[4], tokens[5]);
    var timestampWithMsZeroed = date.getTime() - date.getTime() % 1000;
    return -(asUTC - timestampWithMsZeroed);
  }

  return 0;
}

function validateTimezone$1(hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false;
  }

  return true;
}

var MILLISECONDS_IN_MINUTE$2 = 60 * 1000;
var formatters$2 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone ? tzParseTimezone(options.timeZone, originalDate) / MILLISECONDS_IN_MINUTE$2 : originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimeter
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone ? tzParseTimezone(options.timeZone, originalDate) / MILLISECONDS_IN_MINUTE$2 : originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimeter
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone ? tzParseTimezone(options.timeZone, originalDate) / MILLISECONDS_IN_MINUTE$2 : originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort$1(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return tzIntlTimeZoneName('short', originalDate, options);
      // Long

      case 'zzzz':
      default:
        return tzIntlTimeZoneName('long', originalDate, options);
    }
  }
};

function addLeadingZeros$1(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

function formatTimezone$1(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros$1(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros$1(absOffset % 60, 2);
  return sign + hours + delimeter + minutes;
}

function formatTimezoneWithOptionalMinutes$1(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros$1(Math.abs(offset) / 60, 2);
  }

  return formatTimezone$1(offset, dirtyDelimeter);
}

function formatTimezoneShort$1(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros$1(minutes, 2);
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$3 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns$1 = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // timezone tokens (to identify the presence of a tz)
  timezone: /([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function toDate$1(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  } // Clone the date


  if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timezone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timezone || options.timeZone, new Date(timestamp + time));

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns$1.dateTimeDelimeter);
  var timeString;

  if (patterns$1.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    dateStrings.timezone = array[2];

    if (patterns$1.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns$1.timeZoneDelimeter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns$1.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns$1.YYY[additionalDigits];
  var patternYYYYY = patterns$1.YYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = patterns$1.YYYY.exec(dateString) || patternYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = patterns$1.YY.exec(dateString) || patternYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = patterns$1.MM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = patterns$1.DDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // yyyy-MM-dd or YYYYMMDD


  token = patterns$1.MMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = patterns$1.Www.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = patterns$1.WwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = patterns$1.HH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR$1;
  } // hh:mm or hhmm


  token = patterns$1.HHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$3;
  } // hh:mm:ss or hhmmss


  token = patterns$1.HHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$3 + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions


var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }

    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);

  if (isLeapYear && dayOfYear > 366) {
    return false;
  }

  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/esm/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var matches = formatStr.match(tzFormattingTokensRegExp);

  if (matches) {
    var date = toDate$1(dirtyDate, options);
    formatStr = matches.reduce(function (result, token) {
      return token[0] === "'" ? result : result.replace(token, "'" + formatters$2[token[0]](date, token, null, options) + "'");
    }, formatStr);
  }

  return format(dirtyDate, formatStr, options);
}

/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */

function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = toDate$1(dirtyDate, options); // This date has the UTC time values of the input date at the system time zone

  var utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()); // We just need to apply the offset indicated by the time zone to this localized date

  var offsetMilliseconds = tzParseTimezone(timeZone, date);
  return offsetMilliseconds ? subMilliseconds(utcDate, offsetMilliseconds) : utcDate;
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}

/**
 * @name zonedTimeToUtc
 * @category Time Zone Helpers
 * @summary Get the UTC date/time from a date representing local time in a given time zone
 *
 * @description
 * Returns a date instance with the UTC time of the provided date of which the values
 * represented the local time in the time zone specified. In other words, if the input
 * date represented local time in time time zone, the timestamp of the output date will
 * give the equivalent UTC of that local time regardless of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am in Los Angeles is 5pm UTC
 * const result = zonedTimeToUtc(new Date(2014, 5, 25, 10, 0, 0), 'America/Los_Angeles')
 * //=> 2014-06-25T17:00:00.000Z
 */

function zonedTimeToUtc(date, timeZone, options) {
  if (date instanceof Date) {
    date = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
  }

  var extendedOptions = cloneObject(options);
  extendedOptions.timeZone = timeZone;
  return toDate$1(date, extendedOptions);
}

var daysNumber = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6
};
var numbersDay = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};

var transformConditions = function transformConditions(conditions) {
  return reduce(conditions, function (acc, value, key) {
    return _objectSpread2({}, acc, _defineProperty({}, daysNumber[key], value));
  }, {});
};

var timeToLocal = function timeToLocal(time, timezone) {
  if (!time) return '';
  var now = utcToZonedTime(Date.now(), timezone);
  var utc = zonedTimeToUtc("".concat(format$1(now, 'yyyy-MM-dd'), "T").concat(time), timezone);
  return format$1(utc, 'hh:mm a');
};

var getNextWorkingHours = function getNextWorkingHours(_ref) {
  var conditions = _ref.conditions,
      day = _ref.day,
      time = _ref.time,
      timezone = _ref.timezone,
      _ref$initial = _ref.initial,
      initial = _ref$initial === void 0 ? false : _ref$initial;
  var startTime = get(conditions, [day, 'start']);
  var stopTime = get(conditions, [day, 'stop']);
  var breaks = get(conditions, [day, 'breaks']);
  var hasDayConditions = has(conditions, day);
  var isBeforeStartTime = time < startTime;
  var nextDay = day + 1 > 6 ? 0 : day + 1;

  if (!hasDayConditions) {
    return getNextWorkingHours({
      conditions: conditions,
      day: nextDay,
      time: time,
      timezone: timezone
    });
  }

  if (initial) {
    if (isBeforeStartTime) {
      return getNextWorkingHours({
        conditions: conditions,
        day: nextDay,
        time: time,
        timezone: timezone
      });
    }
  }

  return {
    day: initial ? 'Today' : numbersDay[day],
    time: "".concat(timeToLocal(startTime, timezone), " - ").concat(timeToLocal(stopTime, timezone)),
    breaks: map$1(breaks, function (_ref2) {
      var start = _ref2.start,
          stop = _ref2.stop;
      return {
        start: timeToLocal(start, timezone),
        stop: timeToLocal(stop, timezone)
      };
    })
  };
};

var transformScheduling = (function (conditions, timezone) {
  var validatedTimezone = validateTimezone(timezone);
  var now = utcToZonedTime(Date.now(), validatedTimezone);
  var sNowTime = format$1(now, 'HH:mm:ss');
  var day = now.getDay();
  var transformedConditions = transformConditions(conditions);
  return getNextWorkingHours({
    day: day,
    conditions: transformedConditions,
    time: sNowTime,
    timezone: validatedTimezone,
    initial: true
  });
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
  return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
  Promise: undefined,

  set useDeprecatedSynchronousErrorHandling(value) {
    if (value) {
      var error =
      /*@__PURE__*/
      new Error();
      /*@__PURE__*/

      console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
    }

    _enable_super_gross_mode_that_will_cause_bad_things = value;
  },

  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }

};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
  setTimeout(function () {
    throw err;
  }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty = {
  closed: true,
  next: function (value) {},
  error: function (err) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      throw err;
    } else {
      hostReportError(err);
    }
  },
  complete: function () {}
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray =
/*@__PURE__*/
function () {
  return Array.isArray || function (x) {
    return x && typeof x.length === 'number';
  };
}();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
  return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl =
/*@__PURE__*/
function () {
  function UnsubscriptionErrorImpl(errors) {
    Error.call(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
    return this;
  }

  UnsubscriptionErrorImpl.prototype =
  /*@__PURE__*/
  Object.create(Error.prototype);
  return UnsubscriptionErrorImpl;
}();

var UnsubscriptionError = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */

var Subscription =
/*@__PURE__*/
function () {
  function Subscription(unsubscribe) {
    this.closed = false;
    this._parentOrParents = null;
    this._subscriptions = null;

    if (unsubscribe) {
      this._unsubscribe = unsubscribe;
    }
  }

  Subscription.prototype.unsubscribe = function () {
    var errors;

    if (this.closed) {
      return;
    }

    var _a = this,
        _parentOrParents = _a._parentOrParents,
        _unsubscribe = _a._unsubscribe,
        _subscriptions = _a._subscriptions;

    this.closed = true;
    this._parentOrParents = null;
    this._subscriptions = null;

    if (_parentOrParents instanceof Subscription) {
      _parentOrParents.remove(this);
    } else if (_parentOrParents !== null) {
      for (var index = 0; index < _parentOrParents.length; ++index) {
        var parent_1 = _parentOrParents[index];
        parent_1.remove(this);
      }
    }

    if (isFunction(_unsubscribe)) {
      try {
        _unsubscribe.call(this);
      } catch (e) {
        errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
      }
    }

    if (isArray(_subscriptions)) {
      var index = -1;
      var len = _subscriptions.length;

      while (++index < len) {
        var sub = _subscriptions[index];

        if (isObject(sub)) {
          try {
            sub.unsubscribe();
          } catch (e) {
            errors = errors || [];

            if (e instanceof UnsubscriptionError) {
              errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
            } else {
              errors.push(e);
            }
          }
        }
      }
    }

    if (errors) {
      throw new UnsubscriptionError(errors);
    }
  };

  Subscription.prototype.add = function (teardown) {
    var subscription = teardown;

    if (!teardown) {
      return Subscription.EMPTY;
    }

    switch (typeof teardown) {
      case 'function':
        subscription = new Subscription(teardown);

      case 'object':
        if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
          return subscription;
        } else if (this.closed) {
          subscription.unsubscribe();
          return subscription;
        } else if (!(subscription instanceof Subscription)) {
          var tmp = subscription;
          subscription = new Subscription();
          subscription._subscriptions = [tmp];
        }

        break;

      default:
        {
          throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
    }

    var _parentOrParents = subscription._parentOrParents;

    if (_parentOrParents === null) {
      subscription._parentOrParents = this;
    } else if (_parentOrParents instanceof Subscription) {
      if (_parentOrParents === this) {
        return subscription;
      }

      subscription._parentOrParents = [_parentOrParents, this];
    } else if (_parentOrParents.indexOf(this) === -1) {
      _parentOrParents.push(this);
    } else {
      return subscription;
    }

    var subscriptions = this._subscriptions;

    if (subscriptions === null) {
      this._subscriptions = [subscription];
    } else {
      subscriptions.push(subscription);
    }

    return subscription;
  };

  Subscription.prototype.remove = function (subscription) {
    var subscriptions = this._subscriptions;

    if (subscriptions) {
      var subscriptionIndex = subscriptions.indexOf(subscription);

      if (subscriptionIndex !== -1) {
        subscriptions.splice(subscriptionIndex, 1);
      }
    }
  };

  Subscription.EMPTY = function (empty) {
    empty.closed = true;
    return empty;
  }(new Subscription());

  return Subscription;
}();

function flattenUnsubscriptionErrors(errors) {
  return errors.reduce(function (errs, err) {
    return errs.concat(err instanceof UnsubscriptionError ? err.errors : err);
  }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber =
/*@__PURE__*/
function () {
  return typeof Symbol === 'function' ?
  /*@__PURE__*/
  Symbol('rxSubscriber') : '@@rxSubscriber_' +
  /*@__PURE__*/
  Math.random();
}();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */

var Subscriber =
/*@__PURE__*/
function (_super) {
  __extends(Subscriber, _super);

  function Subscriber(destinationOrNext, error, complete) {
    var _this = _super.call(this) || this;

    _this.syncErrorValue = null;
    _this.syncErrorThrown = false;
    _this.syncErrorThrowable = false;
    _this.isStopped = false;

    switch (arguments.length) {
      case 0:
        _this.destination = empty;
        break;

      case 1:
        if (!destinationOrNext) {
          _this.destination = empty;
          break;
        }

        if (typeof destinationOrNext === 'object') {
          if (destinationOrNext instanceof Subscriber) {
            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
            _this.destination = destinationOrNext;
            destinationOrNext.add(_this);
          } else {
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber(_this, destinationOrNext);
          }

          break;
        }

      default:
        _this.syncErrorThrowable = true;
        _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
        break;
    }

    return _this;
  }

  Subscriber.prototype[rxSubscriber] = function () {
    return this;
  };

  Subscriber.create = function (next, error, complete) {
    var subscriber = new Subscriber(next, error, complete);
    subscriber.syncErrorThrowable = false;
    return subscriber;
  };

  Subscriber.prototype.next = function (value) {
    if (!this.isStopped) {
      this._next(value);
    }
  };

  Subscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      this.isStopped = true;

      this._error(err);
    }
  };

  Subscriber.prototype.complete = function () {
    if (!this.isStopped) {
      this.isStopped = true;

      this._complete();
    }
  };

  Subscriber.prototype.unsubscribe = function () {
    if (this.closed) {
      return;
    }

    this.isStopped = true;

    _super.prototype.unsubscribe.call(this);
  };

  Subscriber.prototype._next = function (value) {
    this.destination.next(value);
  };

  Subscriber.prototype._error = function (err) {
    this.destination.error(err);
    this.unsubscribe();
  };

  Subscriber.prototype._complete = function () {
    this.destination.complete();
    this.unsubscribe();
  };

  Subscriber.prototype._unsubscribeAndRecycle = function () {
    var _parentOrParents = this._parentOrParents;
    this._parentOrParents = null;
    this.unsubscribe();
    this.closed = false;
    this.isStopped = false;
    this._parentOrParents = _parentOrParents;
    return this;
  };

  return Subscriber;
}(Subscription);

var SafeSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(SafeSubscriber, _super);

  function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
    var _this = _super.call(this) || this;

    _this._parentSubscriber = _parentSubscriber;
    var next;
    var context = _this;

    if (isFunction(observerOrNext)) {
      next = observerOrNext;
    } else if (observerOrNext) {
      next = observerOrNext.next;
      error = observerOrNext.error;
      complete = observerOrNext.complete;

      if (observerOrNext !== empty) {
        context = Object.create(observerOrNext);

        if (isFunction(context.unsubscribe)) {
          _this.add(context.unsubscribe.bind(context));
        }

        context.unsubscribe = _this.unsubscribe.bind(_this);
      }
    }

    _this._context = context;
    _this._next = next;
    _this._error = error;
    _this._complete = complete;
    return _this;
  }

  SafeSubscriber.prototype.next = function (value) {
    if (!this.isStopped && this._next) {
      var _parentSubscriber = this._parentSubscriber;

      if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
        this.__tryOrUnsub(this._next, value);
      } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;

      if (this._error) {
        if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(this._error, err);

          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, this._error, err);

          this.unsubscribe();
        }
      } else if (!_parentSubscriber.syncErrorThrowable) {
        this.unsubscribe();

        if (useDeprecatedSynchronousErrorHandling) {
          throw err;
        }

        hostReportError(err);
      } else {
        if (useDeprecatedSynchronousErrorHandling) {
          _parentSubscriber.syncErrorValue = err;
          _parentSubscriber.syncErrorThrown = true;
        } else {
          hostReportError(err);
        }

        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.complete = function () {
    var _this = this;

    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;

      if (this._complete) {
        var wrappedComplete = function () {
          return _this._complete.call(_this._context);
        };

        if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(wrappedComplete);

          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, wrappedComplete);

          this.unsubscribe();
        }
      } else {
        this.unsubscribe();
      }
    }
  };

  SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
    try {
      fn.call(this._context, value);
    } catch (err) {
      this.unsubscribe();

      if (config.useDeprecatedSynchronousErrorHandling) {
        throw err;
      } else {
        hostReportError(err);
      }
    }
  };

  SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
    if (!config.useDeprecatedSynchronousErrorHandling) {
      throw new Error('bad call');
    }

    try {
      fn.call(this._context, value);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        parent.syncErrorValue = err;
        parent.syncErrorThrown = true;
        return true;
      } else {
        hostReportError(err);
        return true;
      }
    }

    return false;
  };

  SafeSubscriber.prototype._unsubscribe = function () {
    var _parentSubscriber = this._parentSubscriber;
    this._context = null;
    this._parentSubscriber = null;

    _parentSubscriber.unsubscribe();
  };

  return SafeSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */

var OuterSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(OuterSubscriber, _super);

  function OuterSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
    this.destination.next(innerValue);
  };

  OuterSubscriber.prototype.notifyError = function (error, innerSub) {
    this.destination.error(error);
  };

  OuterSubscriber.prototype.notifyComplete = function (innerSub) {
    this.destination.complete();
  };

  return OuterSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */

var InnerSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(InnerSubscriber, _super);

  function InnerSubscriber(parent, outerValue, outerIndex) {
    var _this = _super.call(this) || this;

    _this.parent = parent;
    _this.outerValue = outerValue;
    _this.outerIndex = outerIndex;
    _this.index = 0;
    return _this;
  }

  InnerSubscriber.prototype._next = function (value) {
    this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
  };

  InnerSubscriber.prototype._error = function (error) {
    this.parent.notifyError(error, this);
    this.unsubscribe();
  };

  InnerSubscriber.prototype._complete = function () {
    this.parent.notifyComplete(this);
    this.unsubscribe();
  };

  return InnerSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
  return function (subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }

    subscriber.complete();
  };
};

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
  return function (subscriber) {
    promise.then(function (value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function (err) {
      return subscriber.error(err);
    }).then(null, hostReportError);
    return subscriber;
  };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }

  return Symbol.iterator;
}
var iterator =
/*@__PURE__*/
getSymbolIterator();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
  return function (subscriber) {
    var iterator$1 = iterable[iterator]();

    do {
      var item = iterator$1.next();

      if (item.done) {
        subscriber.complete();
        break;
      }

      subscriber.next(item.value);

      if (subscriber.closed) {
        break;
      }
    } while (true);

    if (typeof iterator$1.return === 'function') {
      subscriber.add(function () {
        if (iterator$1.return) {
          iterator$1.return();
        }
      });
    }

    return subscriber;
  };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable =
/*@__PURE__*/
function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
  return function (subscriber) {
    var obs = obj[observable]();

    if (typeof obs.subscribe !== 'function') {
      throw new TypeError('Provided object does not correctly implement Symbol.observable');
    } else {
      return obs.subscribe(subscriber);
    }
  };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = function (x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
  return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
  if (!!result && typeof result[observable] === 'function') {
    return subscribeToObservable(result);
  } else if (isArrayLike(result)) {
    return subscribeToArray(result);
  } else if (isPromise(result)) {
    return subscribeToPromise(result);
  } else if (!!result && typeof result[iterator] === 'function') {
    return subscribeToIterable(result);
  } else {
    var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
    var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
    throw new TypeError(msg);
  }
};

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
  while (observer) {
    var _a = observer,
        closed_1 = _a.closed,
        destination = _a.destination,
        isStopped = _a.isStopped;

    if (closed_1 || isStopped) {
      return false;
    } else if (destination && destination instanceof Subscriber) {
      observer = destination;
    } else {
      observer = null;
    }
  }

  return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
  if (nextOrObserver) {
    if (nextOrObserver instanceof Subscriber) {
      return nextOrObserver;
    }

    if (nextOrObserver[rxSubscriber]) {
      return nextOrObserver[rxSubscriber]();
    }
  }

  if (!nextOrObserver && !error && !complete) {
    return new Subscriber(empty);
  }

  return new Subscriber(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() {}

/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */
function pipeFromArray(fns) {
  if (!fns) {
    return noop;
  }

  if (fns.length === 1) {
    return fns[0];
  }

  return function piped(input) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, input);
  };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */

var Observable =
/*@__PURE__*/
function () {
  function Observable(subscribe) {
    this._isScalar = false;

    if (subscribe) {
      this._subscribe = subscribe;
    }
  }

  Observable.prototype.lift = function (operator) {
    var observable = new Observable();
    observable.source = this;
    observable.operator = operator;
    return observable;
  };

  Observable.prototype.subscribe = function (observerOrNext, error, complete) {
    var operator = this.operator;
    var sink = toSubscriber(observerOrNext, error, complete);

    if (operator) {
      sink.add(operator.call(sink, this.source));
    } else {
      sink.add(this.source || config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
    }

    if (config.useDeprecatedSynchronousErrorHandling) {
      if (sink.syncErrorThrowable) {
        sink.syncErrorThrowable = false;

        if (sink.syncErrorThrown) {
          throw sink.syncErrorValue;
        }
      }
    }

    return sink;
  };

  Observable.prototype._trySubscribe = function (sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        sink.syncErrorThrown = true;
        sink.syncErrorValue = err;
      }

      if (canReportError(sink)) {
        sink.error(err);
      } else {
        console.warn(err);
      }
    }
  };

  Observable.prototype.forEach = function (next, promiseCtor) {
    var _this = this;

    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var subscription;
      subscription = _this.subscribe(function (value) {
        try {
          next(value);
        } catch (err) {
          reject(err);

          if (subscription) {
            subscription.unsubscribe();
          }
        }
      }, reject, resolve);
    });
  };

  Observable.prototype._subscribe = function (subscriber) {
    var source = this.source;
    return source && source.subscribe(subscriber);
  };

  Observable.prototype[observable] = function () {
    return this;
  };

  Observable.prototype.pipe = function () {
    var operations = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }

    if (operations.length === 0) {
      return this;
    }

    return pipeFromArray(operations)(this);
  };

  Observable.prototype.toPromise = function (promiseCtor) {
    var _this = this;

    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var value;

      _this.subscribe(function (x) {
        return value = x;
      }, function (err) {
        return reject(err);
      }, function () {
        return resolve(value);
      });
    });
  };

  Observable.create = function (subscribe) {
    return new Observable(subscribe);
  };

  return Observable;
}();

function getPromiseCtor(promiseCtor) {
  if (!promiseCtor) {
    promiseCtor =  Promise;
  }

  if (!promiseCtor) {
    throw new Error('no Promise impl found');
  }

  return promiseCtor;
}

/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
  if (innerSubscriber === void 0) {
    innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
  }

  if (innerSubscriber.closed) {
    return undefined;
  }

  if (result instanceof Observable) {
    return result.subscribe(innerSubscriber);
  }

  return subscribeTo(result)(innerSubscriber);
}

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */

var Action =
/*@__PURE__*/
function (_super) {
  __extends(Action, _super);

  function Action(scheduler, work) {
    return _super.call(this) || this;
  }

  Action.prototype.schedule = function (state, delay) {

    return this;
  };

  return Action;
}(Subscription);

/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */

var AsyncAction =
/*@__PURE__*/
function (_super) {
  __extends(AsyncAction, _super);

  function AsyncAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;

    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }

  AsyncAction.prototype.schedule = function (state, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    if (this.closed) {
      return this;
    }

    this.state = state;
    var id = this.id;
    var scheduler = this.scheduler;

    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, delay);
    }

    this.pending = true;
    this.delay = delay;
    this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };

  AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    return setInterval(scheduler.flush.bind(scheduler, this), delay);
  };

  AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }

    if (delay !== null && this.delay === delay && this.pending === false) {
      return id;
    }

    clearInterval(id);
    return undefined;
  };

  AsyncAction.prototype.execute = function (state, delay) {
    if (this.closed) {
      return new Error('executing a cancelled action');
    }

    this.pending = false;

    var error = this._execute(state, delay);

    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };

  AsyncAction.prototype._execute = function (state, delay) {
    var errored = false;
    var errorValue = undefined;

    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = !!e && e || new Error(e);
    }

    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };

  AsyncAction.prototype._unsubscribe = function () {
    var id = this.id;
    var scheduler = this.scheduler;
    var actions = scheduler.actions;
    var index = actions.indexOf(this);
    this.work = null;
    this.state = null;
    this.pending = false;
    this.scheduler = null;

    if (index !== -1) {
      actions.splice(index, 1);
    }

    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, null);
    }

    this.delay = null;
  };

  return AsyncAction;
}(Action);

var Scheduler =
/*@__PURE__*/
function () {
  function Scheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }

    this.SchedulerAction = SchedulerAction;
    this.now = now;
  }

  Scheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }

    return new this.SchedulerAction(this, work).schedule(state, delay);
  };

  Scheduler.now = function () {
    return Date.now();
  };

  return Scheduler;
}();

/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */

var AsyncScheduler =
/*@__PURE__*/
function (_super) {
  __extends(AsyncScheduler, _super);

  function AsyncScheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }

    var _this = _super.call(this, SchedulerAction, function () {
      if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
        return AsyncScheduler.delegate.now();
      } else {
        return now();
      }
    }) || this;

    _this.actions = [];
    _this.active = false;
    _this.scheduled = undefined;
    return _this;
  }

  AsyncScheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }

    if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
      return AsyncScheduler.delegate.schedule(work, delay, state);
    } else {
      return _super.prototype.schedule.call(this, work, delay, state);
    }
  };

  AsyncScheduler.prototype.flush = function (action) {
    var actions = this.actions;

    if (this.active) {
      actions.push(action);
      return;
    }

    var error;
    this.active = true;

    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());

    this.active = false;

    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }

      throw error;
    }
  };

  return AsyncScheduler;
}(Scheduler);

/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var async =
/*@__PURE__*/
new AsyncScheduler(AsyncAction);

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
  return value && typeof value.schedule === 'function';
}

/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
function catchError(selector) {
  return function catchErrorOperatorFunction(source) {
    var operator = new CatchOperator(selector);
    var caught = source.lift(operator);
    return operator.caught = caught;
  };
}

var CatchOperator =
/*@__PURE__*/
function () {
  function CatchOperator(selector) {
    this.selector = selector;
  }

  CatchOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
  };

  return CatchOperator;
}();

var CatchSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(CatchSubscriber, _super);

  function CatchSubscriber(destination, selector, caught) {
    var _this = _super.call(this, destination) || this;

    _this.selector = selector;
    _this.caught = caught;
    return _this;
  }

  CatchSubscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      var result = void 0;

      try {
        result = this.selector(err, this.caught);
      } catch (err2) {
        _super.prototype.error.call(this, err2);

        return;
      }

      this._unsubscribeAndRecycle();

      var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
      this.add(innerSubscriber);
      var innerSubscription = subscribeToResult(this, result, undefined, undefined, innerSubscriber);

      if (innerSubscription !== innerSubscriber) {
        this.add(innerSubscription);
      }
    }
  };

  return CatchSubscriber;
}(OuterSubscriber);

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function scheduleArray(input, scheduler) {
  return new Observable(function (subscriber) {
    var sub = new Subscription();
    var i = 0;
    sub.add(scheduler.schedule(function () {
      if (i === input.length) {
        subscriber.complete();
        return;
      }

      subscriber.next(input[i++]);

      if (!subscriber.closed) {
        sub.add(this.schedule());
      }
    }));
    return sub;
  });
}

/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function fromArray(input, scheduler) {
  if (!scheduler) {
    return new Observable(subscribeToArray(input));
  } else {
    return scheduleArray(input, scheduler);
  }
}

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
function scheduleObservable(input, scheduler) {
  return new Observable(function (subscriber) {
    var sub = new Subscription();
    sub.add(scheduler.schedule(function () {
      var observable$1 = input[observable]();
      sub.add(observable$1.subscribe({
        next: function (value) {
          sub.add(scheduler.schedule(function () {
            return subscriber.next(value);
          }));
        },
        error: function (err) {
          sub.add(scheduler.schedule(function () {
            return subscriber.error(err);
          }));
        },
        complete: function () {
          sub.add(scheduler.schedule(function () {
            return subscriber.complete();
          }));
        }
      }));
    }));
    return sub;
  });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function schedulePromise(input, scheduler) {
  return new Observable(function (subscriber) {
    var sub = new Subscription();
    sub.add(scheduler.schedule(function () {
      return input.then(function (value) {
        sub.add(scheduler.schedule(function () {
          subscriber.next(value);
          sub.add(scheduler.schedule(function () {
            return subscriber.complete();
          }));
        }));
      }, function (err) {
        sub.add(scheduler.schedule(function () {
          return subscriber.error(err);
        }));
      });
    }));
    return sub;
  });
}

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
function scheduleIterable(input, scheduler) {
  if (!input) {
    throw new Error('Iterable cannot be null');
  }

  return new Observable(function (subscriber) {
    var sub = new Subscription();
    var iterator$1;
    sub.add(function () {
      if (iterator$1 && typeof iterator$1.return === 'function') {
        iterator$1.return();
      }
    });
    sub.add(scheduler.schedule(function () {
      iterator$1 = input[iterator]();
      sub.add(scheduler.schedule(function () {
        if (subscriber.closed) {
          return;
        }

        var value;
        var done;

        try {
          var result = iterator$1.next();
          value = result.value;
          done = result.done;
        } catch (err) {
          subscriber.error(err);
          return;
        }

        if (done) {
          subscriber.complete();
        } else {
          subscriber.next(value);
          this.schedule();
        }
      }));
    }));
    return sub;
  });
}

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
function isInteropObservable(input) {
  return input && typeof input[observable] === 'function';
}

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
function isIterable(input) {
  return input && typeof input[iterator] === 'function';
}

/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
function scheduled(input, scheduler) {
  if (input != null) {
    if (isInteropObservable(input)) {
      return scheduleObservable(input, scheduler);
    } else if (isPromise(input)) {
      return schedulePromise(input, scheduler);
    } else if (isArrayLike(input)) {
      return scheduleArray(input, scheduler);
    } else if (isIterable(input) || typeof input === 'string') {
      return scheduleIterable(input, scheduler);
    }
  }

  throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
function from(input, scheduler) {
  if (!scheduler) {
    if (input instanceof Observable) {
      return input;
    }

    return new Observable(subscribeTo(input));
  } else {
    return scheduled(input, scheduler);
  }
}

/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function of() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var scheduler = args[args.length - 1];

  if (isScheduler(scheduler)) {
    args.pop();
    return scheduleArray(args, scheduler);
  } else {
    return fromArray(args);
  }
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map(project, thisArg) {
  return function mapOperation(source) {
    if (typeof project !== 'function') {
      throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }

    return source.lift(new MapOperator(project, thisArg));
  };
}

var MapOperator =
/*@__PURE__*/
function () {
  function MapOperator(project, thisArg) {
    this.project = project;
    this.thisArg = thisArg;
  }

  MapOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
  };

  return MapOperator;
}();

var MapSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(MapSubscriber, _super);

  function MapSubscriber(destination, project, thisArg) {
    var _this = _super.call(this, destination) || this;

    _this.project = project;
    _this.count = 0;
    _this.thisArg = thisArg || _this;
    return _this;
  }

  MapSubscriber.prototype._next = function (value) {
    var result;

    try {
      result = this.project.call(this.thisArg, value, this.count++);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.destination.next(result);
  };

  return MapSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber,_map,_observable_from PURE_IMPORTS_END */
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Number.POSITIVE_INFINITY;
  }

  if (typeof resultSelector === 'function') {
    return function (source) {
      return source.pipe(mergeMap(function (a, i) {
        return from(project(a, i)).pipe(map(function (b, ii) {
          return resultSelector(a, b, i, ii);
        }));
      }, concurrent));
    };
  } else if (typeof resultSelector === 'number') {
    concurrent = resultSelector;
  }

  return function (source) {
    return source.lift(new MergeMapOperator(project, concurrent));
  };
}

var MergeMapOperator =
/*@__PURE__*/
function () {
  function MergeMapOperator(project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }

    this.project = project;
    this.concurrent = concurrent;
  }

  MergeMapOperator.prototype.call = function (observer, source) {
    return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
  };

  return MergeMapOperator;
}();

var MergeMapSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(MergeMapSubscriber, _super);

  function MergeMapSubscriber(destination, project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }

    var _this = _super.call(this, destination) || this;

    _this.project = project;
    _this.concurrent = concurrent;
    _this.hasCompleted = false;
    _this.buffer = [];
    _this.active = 0;
    _this.index = 0;
    return _this;
  }

  MergeMapSubscriber.prototype._next = function (value) {
    if (this.active < this.concurrent) {
      this._tryNext(value);
    } else {
      this.buffer.push(value);
    }
  };

  MergeMapSubscriber.prototype._tryNext = function (value) {
    var result;
    var index = this.index++;

    try {
      result = this.project(value, index);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.active++;

    this._innerSub(result, value, index);
  };

  MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
    var innerSubscriber = new InnerSubscriber(this, value, index);
    var destination = this.destination;
    destination.add(innerSubscriber);
    var innerSubscription = subscribeToResult(this, ish, undefined, undefined, innerSubscriber);

    if (innerSubscription !== innerSubscriber) {
      destination.add(innerSubscription);
    }
  };

  MergeMapSubscriber.prototype._complete = function () {
    this.hasCompleted = true;

    if (this.active === 0 && this.buffer.length === 0) {
      this.destination.complete();
    }

    this.unsubscribe();
  };

  MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
    this.destination.next(innerValue);
  };

  MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
    var buffer = this.buffer;
    this.remove(innerSub);
    this.active--;

    if (buffer.length > 0) {
      this._next(buffer.shift());
    } else if (this.active === 0 && this.hasCompleted) {
      this.destination.complete();
    }
  };

  return MergeMapSubscriber;
}(OuterSubscriber);

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
var EMPTY =
/*@__PURE__*/
new Observable(function (subscriber) {
  return subscriber.complete();
});
function empty$1(scheduler) {
  return scheduler ? emptyScheduled(scheduler) : EMPTY;
}

function emptyScheduled(scheduler) {
  return new Observable(function (subscriber) {
    return scheduler.schedule(function () {
      return subscriber.complete();
    });
  });
}

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function throwError(error, scheduler) {
  if (!scheduler) {
    return new Observable(function (subscriber) {
      return subscriber.error(error);
    });
  } else {
    return new Observable(function (subscriber) {
      return scheduler.schedule(dispatch, 0, {
        error: error,
        subscriber: subscriber
      });
    });
  }
}

function dispatch(_a) {
  var error = _a.error,
      subscriber = _a.subscriber;
  subscriber.error(error);
}

/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */

var Notification =
/*@__PURE__*/
function () {
  function Notification(kind, value, error) {
    this.kind = kind;
    this.value = value;
    this.error = error;
    this.hasValue = kind === 'N';
  }

  Notification.prototype.observe = function (observer) {
    switch (this.kind) {
      case 'N':
        return observer.next && observer.next(this.value);

      case 'E':
        return observer.error && observer.error(this.error);

      case 'C':
        return observer.complete && observer.complete();
    }
  };

  Notification.prototype.do = function (next, error, complete) {
    var kind = this.kind;

    switch (kind) {
      case 'N':
        return next && next(this.value);

      case 'E':
        return error && error(this.error);

      case 'C':
        return complete && complete();
    }
  };

  Notification.prototype.accept = function (nextOrObserver, error, complete) {
    if (nextOrObserver && typeof nextOrObserver.next === 'function') {
      return this.observe(nextOrObserver);
    } else {
      return this.do(nextOrObserver, error, complete);
    }
  };

  Notification.prototype.toObservable = function () {
    var kind = this.kind;

    switch (kind) {
      case 'N':
        return of(this.value);

      case 'E':
        return throwError(this.error);

      case 'C':
        return empty$1();
    }

    throw new Error('unexpected notification kind value');
  };

  Notification.createNext = function (value) {
    if (typeof value !== 'undefined') {
      return new Notification('N', value);
    }

    return Notification.undefinedValueNotification;
  };

  Notification.createError = function (err) {
    return new Notification('E', undefined, err);
  };

  Notification.createComplete = function () {
    return Notification.completeNotification;
  };

  Notification.completeNotification = new Notification('C');
  Notification.undefinedValueNotification = new Notification('N', undefined);
  return Notification;
}();

/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */
function delay(delay, scheduler) {
  if (scheduler === void 0) {
    scheduler = async;
  }

  var absoluteDelay = isDate(delay);
  var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
  return function (source) {
    return source.lift(new DelayOperator(delayFor, scheduler));
  };
}

var DelayOperator =
/*@__PURE__*/
function () {
  function DelayOperator(delay, scheduler) {
    this.delay = delay;
    this.scheduler = scheduler;
  }

  DelayOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
  };

  return DelayOperator;
}();

var DelaySubscriber =
/*@__PURE__*/
function (_super) {
  __extends(DelaySubscriber, _super);

  function DelaySubscriber(destination, delay, scheduler) {
    var _this = _super.call(this, destination) || this;

    _this.delay = delay;
    _this.scheduler = scheduler;
    _this.queue = [];
    _this.active = false;
    _this.errored = false;
    return _this;
  }

  DelaySubscriber.dispatch = function (state) {
    var source = state.source;
    var queue = source.queue;
    var scheduler = state.scheduler;
    var destination = state.destination;

    while (queue.length > 0 && queue[0].time - scheduler.now() <= 0) {
      queue.shift().notification.observe(destination);
    }

    if (queue.length > 0) {
      var delay_1 = Math.max(0, queue[0].time - scheduler.now());
      this.schedule(state, delay_1);
    } else {
      this.unsubscribe();
      source.active = false;
    }
  };

  DelaySubscriber.prototype._schedule = function (scheduler) {
    this.active = true;
    var destination = this.destination;
    destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
      source: this,
      destination: this.destination,
      scheduler: scheduler
    }));
  };

  DelaySubscriber.prototype.scheduleNotification = function (notification) {
    if (this.errored === true) {
      return;
    }

    var scheduler = this.scheduler;
    var message = new DelayMessage(scheduler.now() + this.delay, notification);
    this.queue.push(message);

    if (this.active === false) {
      this._schedule(scheduler);
    }
  };

  DelaySubscriber.prototype._next = function (value) {
    this.scheduleNotification(Notification.createNext(value));
  };

  DelaySubscriber.prototype._error = function (err) {
    this.errored = true;
    this.queue = [];
    this.destination.error(err);
    this.unsubscribe();
  };

  DelaySubscriber.prototype._complete = function () {
    this.scheduleNotification(Notification.createComplete());
    this.unsubscribe();
  };

  return DelaySubscriber;
}(Subscriber);

var DelayMessage =
/*@__PURE__*/
function () {
  function DelayMessage(time, notification) {
    this.time = time;
    this.notification = notification;
  }

  return DelayMessage;
}();

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function ignoreElements() {
  return function ignoreElementsOperatorFunction(source) {
    return source.lift(new IgnoreElementsOperator());
  };
}

var IgnoreElementsOperator =
/*@__PURE__*/
function () {
  function IgnoreElementsOperator() {}

  IgnoreElementsOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new IgnoreElementsSubscriber(subscriber));
  };

  return IgnoreElementsOperator;
}();

var IgnoreElementsSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(IgnoreElementsSubscriber, _super);

  function IgnoreElementsSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IgnoreElementsSubscriber.prototype._next = function (unused) {};

  return IgnoreElementsSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */
function switchMap(project, resultSelector) {
  if (typeof resultSelector === 'function') {
    return function (source) {
      return source.pipe(switchMap(function (a, i) {
        return from(project(a, i)).pipe(map(function (b, ii) {
          return resultSelector(a, b, i, ii);
        }));
      }));
    };
  }

  return function (source) {
    return source.lift(new SwitchMapOperator(project));
  };
}

var SwitchMapOperator =
/*@__PURE__*/
function () {
  function SwitchMapOperator(project) {
    this.project = project;
  }

  SwitchMapOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
  };

  return SwitchMapOperator;
}();

var SwitchMapSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(SwitchMapSubscriber, _super);

  function SwitchMapSubscriber(destination, project) {
    var _this = _super.call(this, destination) || this;

    _this.project = project;
    _this.index = 0;
    return _this;
  }

  SwitchMapSubscriber.prototype._next = function (value) {
    var result;
    var index = this.index++;

    try {
      result = this.project(value, index);
    } catch (error) {
      this.destination.error(error);
      return;
    }

    this._innerSub(result, value, index);
  };

  SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
    var innerSubscription = this.innerSubscription;

    if (innerSubscription) {
      innerSubscription.unsubscribe();
    }

    var innerSubscriber = new InnerSubscriber(this, value, index);
    var destination = this.destination;
    destination.add(innerSubscriber);
    this.innerSubscription = subscribeToResult(this, result, undefined, undefined, innerSubscriber);

    if (this.innerSubscription !== innerSubscriber) {
      destination.add(this.innerSubscription);
    }
  };

  SwitchMapSubscriber.prototype._complete = function () {
    var innerSubscription = this.innerSubscription;

    if (!innerSubscription || innerSubscription.closed) {
      _super.prototype._complete.call(this);
    }

    this.unsubscribe();
  };

  SwitchMapSubscriber.prototype._unsubscribe = function () {
    this.innerSubscription = null;
  };

  SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
    var destination = this.destination;
    destination.remove(innerSub);
    this.innerSubscription = null;

    if (this.isStopped) {
      _super.prototype._complete.call(this);
    }
  };

  SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
    this.destination.next(innerValue);
  };

  return SwitchMapSubscriber;
}(OuterSubscriber);

/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
function withLatestFrom() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return function (source) {
    var project;

    if (typeof args[args.length - 1] === 'function') {
      project = args.pop();
    }

    var observables = args;
    return source.lift(new WithLatestFromOperator(observables, project));
  };
}

var WithLatestFromOperator =
/*@__PURE__*/
function () {
  function WithLatestFromOperator(observables, project) {
    this.observables = observables;
    this.project = project;
  }

  WithLatestFromOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
  };

  return WithLatestFromOperator;
}();

var WithLatestFromSubscriber =
/*@__PURE__*/
function (_super) {
  __extends(WithLatestFromSubscriber, _super);

  function WithLatestFromSubscriber(destination, observables, project) {
    var _this = _super.call(this, destination) || this;

    _this.observables = observables;
    _this.project = project;
    _this.toRespond = [];
    var len = observables.length;
    _this.values = new Array(len);

    for (var i = 0; i < len; i++) {
      _this.toRespond.push(i);
    }

    for (var i = 0; i < len; i++) {
      var observable = observables[i];

      _this.add(subscribeToResult(_this, observable, observable, i));
    }

    return _this;
  }

  WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
    this.values[outerIndex] = innerValue;
    var toRespond = this.toRespond;

    if (toRespond.length > 0) {
      var found = toRespond.indexOf(outerIndex);

      if (found !== -1) {
        toRespond.splice(found, 1);
      }
    }
  };

  WithLatestFromSubscriber.prototype.notifyComplete = function () {};

  WithLatestFromSubscriber.prototype._next = function (value) {
    if (this.toRespond.length === 0) {
      var args = [value].concat(this.values);

      if (this.project) {
        this._tryProject(args);
      } else {
        this.destination.next(args);
      }
    }
  };

  WithLatestFromSubscriber.prototype._tryProject = function (args) {
    var result;

    try {
      result = this.project.apply(this, args);
    } catch (err) {
      this.destination.error(err);
      return;
    }

    this.destination.next(result);
  };

  return WithLatestFromSubscriber;
}(OuterSubscriber);

var Statuses = {
  Send: 'send',
  Sending: 'sending',
  Sent: 'sent',
  Recieved: 'recieved',
  Read: 'read'
};
var Types$1 = {
  Text: 'text'
};

var message = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Statuses: Statuses,
  Types: Types$1
});

var createAction = function createAction(type) {
  return function (payload) {
    var action = {
      type: type
    };

    if (typeof payload !== 'undefined') {
      action.payload = payload;
    }

    return action;
  };
};

var createActionType = function createActionType(nameSpace, actionType) {
  return "".concat(nameSpace, ":").concat(actionType);
};

var createRequestActionTypes = function createRequestActionTypes(nameSpace, actionType) {
  var actionNameSpace = createActionType(nameSpace, actionType);
  return {
    Fail: createActionType(actionNameSpace, 'Fail'),
    Init: createActionType(actionNameSpace, 'Init'),
    Pending: createActionType(actionNameSpace, 'Pending'),
    Success: createActionType(actionNameSpace, 'Success')
  };
};
var createRequestAction = function createRequestAction(actionTypes) {
  return function (payload) {
    var action = {
      type: actionTypes.Init
    };

    if (payload) {
      action.payload = payload;
    }

    return action;
  };
};

var createRequestEpic = function createRequestEpic(actionTypes, requestCreator, requestChecker) {
  return function (actions$, state$, deps$) {
    var stream$ = actions$.pipe(ofType(actionTypes.Init));
    var UUID = uuid();

    if (requestChecker) {
      stream$ = requestChecker(stream$, state$);
    }

    var pending$ = stream$.pipe(map(function () {
      return {
        type: actionTypes.Pending,
        meta: {
          uuid: UUID
        }
      };
    }));
    var request$ = requestCreator(stream$, state$, deps$).pipe(map(function (response) {
      return {
        meta: {
          uuid: UUID
        },
        payload: response,
        type: actionTypes.Success
      };
    }), catchError(function (error, caught$) {
      return merge(caught$, of$1({
        meta: {
          uuid: UUID
        },
        payload: error,
        type: actionTypes.Fail
      }));
    }));
    return merge(pending$, request$);
  };
};

var namespace = 'Chat';
var namespaceTalks = "".concat(namespace, ":Talks");
var namespaceTalksInvitaion = "".concat(namespaceTalks, ":Invitation");
var namespaceRoster = "".concat(namespace, ":Roster");
var namespaceEvent = "".concat(namespace, ":Event");
var namespaceConnection = "".concat(namespace, ":Connection");
var namespaceSettings = "".concat(namespace, ":Settings");
var namespaceResponsesWaiting = "".concat(namespace, ":ResponsesWaiting");
var namespaceStatus = "".concat(namespace, ":Status");
var namespaceEventInput = "".concat(namespaceEvent, ":Input");
var namespaceEventInputRouting = "".concat(namespaceEventInput, ":Routing");
var namespaceMessage = "".concat(namespace, ":Message");
var namespaceMessageTransferInvitation = "".concat(namespaceMessage, ":TransferInvitation"); // export const namespaceEventInputMessageInvitation = `${namespaceEventInputMessage}:Invitation`;

var namespaceEventOutput = "".concat(namespaceEvent, ":Output");
var namespaceEventOutputMessage = "".concat(namespaceEventOutput, ":Message");
var namespacePresence = "".concat(namespace, ":Presence");
var namespaceEventOutputRouting = "".concat(namespaceEventOutput, ":Routing");
var ActionTypes = {
  InitEventHandler: createActionType(namespace, 'InitEventHandler'),
  Event: {
    Input: {
      Iq: createActionType(namespaceEventInput, 'Iq'),
      Message: {
        TransferInvitation: createActionType(namespaceMessage, 'TransferInvitation'),
        TransferInvitationResponse: createActionType(namespaceMessage, 'TransferInvitationResponse'),
        GroupChatInvitation: createActionType(namespaceMessage, 'GroupChatInvitation'),
        TransferExpired: createActionType(namespaceMessage, 'TransferExpired'),
        TransferInitiated: createActionType(namespaceMessage, 'TransferInitiated')
      },
      Routing: _objectSpread2({
        AgentInvitation: createActionType(namespaceEventInputRouting, 'AgentInvitation'),
        TransferInit: createActionType(namespaceEventInputRouting, 'TransferInit'),
        RemoveOutgoingTransfer: createActionType(namespaceEventInputRouting, 'RemoveOutgoingTransfer'),
        UpdateOutgoingTransfer: createActionType(namespaceEventInputRouting, 'UpdateOutgoingTransfer'),
        RemoveIncomingTransfer: createActionType(namespaceEventInputRouting, 'RemoveIncomingTransfer'),
        TransferInvitationCanceled: createActionType(namespaceEventInputRouting, 'TransferInvitationCanceled'),
        TransferInvitationExpired: createActionType(namespaceEventInputRouting, 'TransferInvitationExpired'),
        LeaveRoom: createActionType(namespaceEventInputRouting, 'LeaveRoom'),
        Flow: createActionType(namespaceEventInputRouting, 'Flow'),
        Unknown: createActionType(namespaceEventInputRouting, 'Unknown')
      }, reduce(Types, function (acc, _value, key) {
        return _objectSpread2({}, acc, _defineProperty({}, key, createActionType(namespaceEventInputRouting, key)));
      }, {})),
      Presence: createActionType(namespaceEventInput, 'Presence'),
      Unsuported: createActionType(namespaceEventInput, 'Unsuported')
    },
    Output: {
      Message: {
        TransferInvitation: createActionType(namespaceEventOutputMessage, 'TransferInvitation'),
        GroupChatInvitation: createActionType(namespaceEventOutputMessage, 'GroupChatInvitation'),
        TransferInvitationResponse: createActionType(namespaceEventOutputMessage, 'TransferInvitationResponse'),
        TransferInvitationCancel: createActionType(namespaceEventOutputMessage, 'TransferInvitationCancel')
      },
      Routing: {
        NextStep: createActionType(namespaceEventOutputRouting, 'NextStep'),
        OutgoingTransfer: createActionType(namespaceEventOutputRouting, 'OutgoingTransfer')
      },
      Unsuported: createActionType(namespaceEventOutput, 'Unsuported')
    },
    Unknown: createActionType(namespaceEvent, 'Unknown')
  },
  Message: {
    Chat: createActionType(namespaceMessage, 'Chat'),
    Send: createActionType(namespaceMessage, 'Send'),
    Sending: createActionType(namespaceMessage, 'Sending'),
    Sent: createActionType(namespaceMessage, 'Sent')
  },
  Status: {
    Online: createActionType(namespaceStatus, 'Online'),
    Offline: createActionType(namespaceStatus, 'Offline'),
    Connecting: createActionType(namespaceStatus, 'Connecting'),
    Connect: createActionType(namespaceStatus, 'Connect'),
    Opening: createActionType(namespaceStatus, 'Opening'),
    Open: createActionType(namespaceStatus, 'Open'),
    Closing: createActionType(namespaceStatus, 'Closing'),
    Close: createActionType(namespaceStatus, 'Close'),
    Disconnecting: createActionType(namespaceStatus, 'Disconnecting'),
    Disconnect: createActionType(namespaceStatus, 'Disconnect'),
    Unknown: createActionType(namespaceStatus, 'Unknown')
  },
  Talks: {
    Add: createActionType(namespaceTalks, 'Add'),
    Leave: createActionType(namespaceTalks, 'Leave'),
    Left: createActionType(namespaceTalks, 'Left'),
    Remove: createActionType(namespaceTalks, 'Remove'),
    Release: createActionType(namespaceTalks, 'Release'),
    Released: createActionType(namespaceTalks, 'Released'),
    Save: createActionType(namespaceTalks, 'Save'),
    Saved: createActionType(namespaceTalks, 'Saved'),
    RequestHistory: createActionType(namespaceTalks, 'RequestHistory'),
    RequestParticipants: createActionType(namespaceTalks, 'RequestParticipants'),
    History: createActionType(namespaceTalks, 'History'),
    Participants: createActionType(namespaceTalks, 'Participants'),
    Meta: createActionType(namespaceTalks, 'Meta'),
    UpdateDescription: createActionType(namespaceTalks, 'UpdateDescription'),
    Invitation: {
      Request: createActionType(namespaceTalksInvitaion, 'Request'),
      Response: createActionType(namespaceTalksInvitaion, 'Response')
    },
    UpdateInputMessage: createActionType(namespaceTalks, 'UpdateInputMessage')
  },
  ResponsesWaiting: {
    Add: createActionType(namespaceResponsesWaiting, 'Add'),
    Remove: createActionType(namespaceResponsesWaiting, 'Remove'),
    Check: createActionType(namespaceResponsesWaiting, 'Check')
  },
  Connection: {
    Connect: createActionType(namespaceConnection, 'Connect'),
    Init: createActionType(namespaceConnection, 'Init')
  },
  UpdateUsersInfo: createActionType(namespace, 'UpdateUsersInfo'),
  UpdateGroupsInfo: createActionType(namespace, 'UpdateGroupsInfo'),
  GetAgentAuthenticationToken: createRequestActionTypes(namespace, 'GetAgentAuthenticationToken'),
  Settings: {
    Request: createActionType(namespaceSettings, 'Request'),
    Response: createActionType(namespaceSettings, 'Response')
  },
  Roster: {
    Request: createActionType(namespaceRoster, 'Request'),
    Response: createActionType(namespaceRoster, 'Response')
  },
  Presence: {
    Send: createActionType(namespacePresence, 'Send'),
    Sent: createActionType(namespacePresence, 'Sent')
  },
  UpdateAppStatus: createActionType(namespace, 'UpdateAppStatus'),
  IsCustomer: createActionType(namespace, 'IsCustomer'),
  UpdateConnectionProps: createActionType(namespace, 'UpdateConnectionProps'),
  AddEventHandler: createActionType(namespace, 'AddEventHandler'),
  RemoveEventHandler: createActionType(namespace, 'RemoveEventHandler'),
  UpdateRoutingStepData: createActionType(namespace, 'UpdateRoutingStepData')
};

var namespace$1 = 'Chat:Events:';

var chatEvents = function chatEvents(names) {
  return zipObject(names, map$1(names, function (name) {
    return "".concat(namespace$1).concat(name);
  }));
};

var ChatEvents = chatEvents(['IncomingChat', 'ChatAccepted', 'ChatDismissed', 'ChatTimedOut', 'ChatInvitationCanceled', 'IncomingTransfer', 'TransferAccepted', 'TransferDeclined', 'TransferCanceled', 'TransferTimedOut', 'SaveChatSuccess']);

var UserStatuses = {
  Away: 'away',
  DND: 'dnd',
  Offline: 'offline',
  Online: 'online'
};

var initialState = {
  app: {
    isCustomer: false,
    XMPP: {
      host: '',
      protocol: 'ws',
      componentDomain: getDomain()
    },
    eventHandlers: {},
    statuses: {}
  },
  statuses: [{
    label: 'online',
    value: UserStatuses.Online
  }, {
    label: 'offline',
    value: UserStatuses.Offline
  }, {
    label: 'away',
    value: UserStatuses.Away
  }, {
    label: 'dnd',
    value: UserStatuses.DND
  }],
  users: {},
  groups: {},
  chats: {},
  messages: {},
  me: '',
  routing: {
    currentStep: undefined,
    stepData: {},
    formMessages: {},
    invitations: {},
    transferInvitations: {},
    outgoingTransfers: {}
  },
  responsesWaitingQueue: {},
  proactivity: {
    enabled: false,
    timeout: 0,
    message: ''
  }
};

var AppStatuses = {
  WindowOpenedOnProactivity: 'windowOpenedOnProactivity'
};

var RosterConstants = {
  Entities: {
    Contact: 'contact',
    Group: 'group'
  }
};



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Message: message,
  Routing: routing,
  ChatEvents: ChatEvents,
  initialState: initialState,
  AppStatuses: AppStatuses,
  Roster: RosterConstants,
  UserStatuses: UserStatuses,
  namespace: namespace,
  namespaceTalks: namespaceTalks,
  namespaceTalksInvitaion: namespaceTalksInvitaion,
  namespaceRoster: namespaceRoster,
  namespaceEvent: namespaceEvent,
  namespaceConnection: namespaceConnection,
  namespaceSettings: namespaceSettings,
  namespaceResponsesWaiting: namespaceResponsesWaiting,
  namespaceStatus: namespaceStatus,
  namespaceEventInput: namespaceEventInput,
  namespaceEventInputRouting: namespaceEventInputRouting,
  namespaceMessage: namespaceMessage,
  namespaceMessageTransferInvitation: namespaceMessageTransferInvitation,
  namespaceEventOutput: namespaceEventOutput,
  namespaceEventOutputMessage: namespaceEventOutputMessage,
  namespacePresence: namespacePresence,
  namespaceEventOutputRouting: namespaceEventOutputRouting,
  ActionTypes: ActionTypes
});

var initEventHandler = createAction(ActionTypes.InitEventHandler);
var updateUsersInfo = createAction(ActionTypes.UpdateUsersInfo);
var updateGroupsInfo = createAction(ActionTypes.UpdateGroupsInfo);
var getAgentAuthenticationToken = createRequestAction(ActionTypes.GetAgentAuthenticationToken);
var isCustomer = createAction(ActionTypes.IsCustomer);
var updateConnectionProps = createAction(ActionTypes.UpdateConnectionProps);
var updateRoutingStepData = createAction(ActionTypes.UpdateRoutingStepData);
var addEventHandler = createAction(ActionTypes.AddEventHandler);
var removeEventHandler = createAction(ActionTypes.RemoveEventHandler);
var updateAppStatus = createAction(ActionTypes.UpdateAppStatus);
var Connection = {
  Connect: createAction(ActionTypes.Connection.Connect),
  Init: createAction(ActionTypes.Connection.Init)
};
var Event = {
  Input: {
    Iq: createAction(ActionTypes.Event.Input.Iq),
    Message: {
      TransferInvitation: createAction(ActionTypes.Event.Input.Message.TransferInvitation),
      TransferInvitationResponse: createAction(ActionTypes.Event.Input.Message.TransferInvitationResponse),
      GroupChatInvitation: createAction(ActionTypes.Event.Input.Message.GroupChatInvitation),
      TransferExpired: createAction(ActionTypes.Event.Input.Message.TransferExpired),
      TransferInitiated: createAction(ActionTypes.Event.Input.Message.TransferInitiated)
    },
    Routing: _objectSpread2({
      AgentInvitation: createAction(ActionTypes.Event.Input.Routing.AgentInvitation),
      TransferInit: createAction(ActionTypes.Event.Input.Routing.TransferInit),
      RemoveOutgoingTransfer: createAction(ActionTypes.Event.Input.Routing.RemoveOutgoingTransfer),
      UpdateOutgoingTransfer: createAction(ActionTypes.Event.Input.Routing.UpdateOutgoingTransfer),
      RemoveIncomingTransfer: createAction(ActionTypes.Event.Input.Routing.RemoveIncomingTransfer),
      TransferInvitationCanceled: createAction(ActionTypes.Event.Input.Routing.TransferInvitationCanceled),
      TransferInvitationExpired: createAction(ActionTypes.Event.Input.Routing.TransferInvitationExpired),
      LeaveRoom: createAction(ActionTypes.Event.Input.Routing.LeaveRoom),
      Flow: createAction(ActionTypes.Event.Input.Routing.Flow),
      Error: createAction(ActionTypes.Event.Input.Routing.Error),
      FormError: createAction(ActionTypes.Event.Input.Routing.FormError),
      Unknown: createAction(ActionTypes.Event.Input.Routing.Unknown)
    }, reduce(Types, function (acc, _value, key) {
      return _objectSpread2({}, acc, _defineProperty({}, key, createAction(ActionTypes.Event.Input.Routing[key])));
    }, {})),
    Presence: createAction(ActionTypes.Event.Input.Presence),
    Unsuported: createAction(ActionTypes.Event.Input.Unsuported)
  },
  Output: {
    Message: {
      TransferInvitation: createAction(ActionTypes.Event.Output.Message.TransferInvitation),
      GroupChatInvitation: createAction(ActionTypes.Event.Output.Message.GroupChatInvitation),
      TransferInvitationResponse: createAction(ActionTypes.Event.Output.Message.TransferInvitationResponse),
      TransferInvitationCancel: createAction(ActionTypes.Event.Output.Message.TransferInvitationCancel)
    },
    Routing: {
      NextStep: createAction(ActionTypes.Event.Output.Routing.NextStep),
      OutgoingTransfer: createAction(ActionTypes.Event.Output.Routing.OutgoingTransfer)
    },
    Unsuported: createAction(ActionTypes.Event.Output.Unsuported)
  },
  Unknown: createAction(ActionTypes.Event.Unknown)
};
var Talks = {
  Add: createAction(ActionTypes.Talks.Add),
  Leave: createAction(ActionTypes.Talks.Leave),
  Left: createAction(ActionTypes.Talks.Left),
  Remove: createAction(ActionTypes.Talks.Remove),
  Release: createAction(ActionTypes.Talks.Release),
  Released: createAction(ActionTypes.Talks.Released),
  Save: createAction(ActionTypes.Talks.Save),
  Saved: createAction(ActionTypes.Talks.Saved),
  RequestHistory: createAction(ActionTypes.Talks.RequestHistory),
  RequestParticipants: createAction(ActionTypes.Talks.RequestParticipants),
  History: createAction(ActionTypes.Talks.History),
  Participants: createAction(ActionTypes.Talks.Participants),
  Meta: createAction(ActionTypes.Talks.Meta),
  UpdateDescription: createAction(ActionTypes.Talks.UpdateDescription),
  Invitation: {
    Request: createAction(ActionTypes.Talks.Invitation.Request),
    Response: createAction(ActionTypes.Talks.Invitation.Response)
  },
  UpdateInputMessage: createAction(ActionTypes.Talks.UpdateInputMessage)
};
var ResponsesWaiting = {
  Add: createAction(ActionTypes.ResponsesWaiting.Add),
  Remove: createAction(ActionTypes.ResponsesWaiting.Remove),
  Check: createAction(ActionTypes.ResponsesWaiting.Check)
};
var Settings = {
  Request: createAction(ActionTypes.Settings.Request),
  Response: createAction(ActionTypes.Settings.Response)
};
var Status = {
  Online: createAction(ActionTypes.Status.Online),
  Offline: createAction(ActionTypes.Status.Offline),
  Connecting: createAction(ActionTypes.Status.Connecting),
  Connect: createAction(ActionTypes.Status.Connect),
  Opening: createAction(ActionTypes.Status.Opening),
  Open: createAction(ActionTypes.Status.Open),
  Closing: createAction(ActionTypes.Status.Closing),
  Close: createAction(ActionTypes.Status.Close),
  Disconnecting: createAction(ActionTypes.Status.Disconnecting),
  Disconnect: createAction(ActionTypes.Status.Disconnect),
  Unknown: createAction(ActionTypes.Status.Unknown)
};
var Roster = {
  Request: createAction(ActionTypes.Roster.Request),
  Response: createAction(ActionTypes.Roster.Response)
};
var Presence = {
  Send: createAction(ActionTypes.Presence.Send),
  Sent: createAction(ActionTypes.Presence.Sent)
};
var Message = {
  Chat: createAction(ActionTypes.Message.Chat),
  Send: createAction(ActionTypes.Message.Send),
  Sending: createAction(ActionTypes.Message.Sending),
  Sent: createAction(ActionTypes.Message.Sent)
};

var initEpic = function initEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Connection.Init), map(function () {
    xmpp.init();
    return false;
  }), ignoreElements());
};

var connectEpic = function connectEpic(action$, state$, _ref2) {
  var xmpp = _ref2.xmpp;
  return action$.pipe(ofType(ActionTypes.Connection.Connect), withLatestFrom(state$), switchMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        _ref4$0$payload = _ref4[0].payload,
        username = _ref4$0$payload.username,
        domain = _ref4$0$payload.domain,
        token = _ref4$0$payload.token,
        state = _ref4[1];

    var jid = "".concat(username, "@").concat(domain);
    var protocol = get(state, ['Chat', 'app', 'XMPP', 'protocol']);
    var host = get(state, ['Chat', 'app', 'XMPP', 'host']);
    var endpoint = get(state, ['Chat', 'app', 'XMPP', 'endpoint']);
    var connectionString = "".concat(host).concat(endpoint);
    xmpp.connect({
      jid: jid,
      protocol: protocol,
      endpoint: connectionString,
      password: token
    });
    return concat(of$1(initEventHandler()), of$1(updateUsersInfo([{
      id: jid,
      domain: domain,
      username: username,
      token: token
    }])));
  }));
};

var connectSuccessEpic = function connectSuccessEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Status.Online), withLatestFrom(state$), switchMap(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        _ref6$1$Chat = _ref6[1].Chat,
        isCustomer = _ref6$1$Chat.app.isCustomer,
        chats = _ref6$1$Chat.chats;

    var eventsToSend = [of$1(Presence.Send('available')), of$1(Settings.Request())];
    var hasActiveChats = !!size(chats);

    if (!isCustomer) {
      eventsToSend.push(of$1(Roster.Request()));
    }

    if (isCustomer && !hasActiveChats) {
      eventsToSend.push(of$1(Event.Output.Routing.NextStep()));
    }

    return concat.apply(void 0, eventsToSend);
  }));
};

var connectDisconnectEpic = function connectDisconnectEpic(action$, state$, _ref7) {
  var xmpp = _ref7.xmpp;
  return action$.pipe(ofType(ActionTypes.Status.Disconnect), withLatestFrom(state$), switchMap(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        isCustomer = _ref9[1].Chat.app.isCustomer;

    var eventsToSend = [];

    if (!isCustomer) {
      xmpp.stop();
      eventsToSend.push(of$1(getAgentAuthenticationToken()));
    }

    return concat.apply(void 0, eventsToSend);
  }));
};

var ConnectEpics = [initEpic, connectEpic, connectSuccessEpic, connectDisconnectEpic];

var authenticationTimeout = 2000;
var agentAuthenticationEpic = createRequestEpic(ActionTypes.GetAgentAuthenticationToken, function (action$, state$, _ref) {
  var request = _ref.request;
  return action$.pipe(switchMap(function () {
    return request('/api/chat-authentication-service/v1/agent/auth-token', {
      method: 'get'
    });
  }));
});

var agentAuthenticationSuccessEpic = function agentAuthenticationSuccessEpic(action$) {
  return action$.pipe(ofType(ActionTypes.GetAgentAuthenticationToken.Success), map(function (_ref2) {
    var _ref2$payload$data = _ref2.payload.data,
        id = _ref2$payload$data.user_id,
        authToken = _ref2$payload$data.auth_token,
        corpAccountNumber = _ref2$payload$data.corp_account_number;
    return Connection.Connect({
      domain: getDomain(),
      username: "agent~~".concat(id, "~~").concat(corpAccountNumber),
      token: authToken,
      corpAccountNumber: corpAccountNumber
    });
  }));
};

var agentAuthenticationFailEpic = function agentAuthenticationFailEpic(action$) {
  return action$.pipe(ofType(ActionTypes.GetAgentAuthenticationToken.Fail), delay(authenticationTimeout), map(function () {
    return getAgentAuthenticationToken();
  }));
};

var AgentAuthenticationEpics = [agentAuthenticationEpic, agentAuthenticationSuccessEpic, agentAuthenticationFailEpic];

var requestChatParticipantsEpic = function requestChatParticipantsEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.RequestParticipants), map(function (_ref2) {
    var jid = _ref2.payload.jid;
    xmpp.sendIQ({
      id: uuid(),
      to: jid,
      fields: {
        'chat-participants': {
          tags: {
            xmlns: 'nextiva:iq:chat-participants'
          }
        }
      }
    });
    return false;
  }), ignoreElements());
};

var chatParticipantsEpic = function chatParticipantsEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Talks.Participants), map(function (_ref3) {
    var children = _ref3.payload.children;
    var usersInfo = map$1(get(find(children, {
      name: 'chat-participants'
    }), 'children'), function (_ref4) {
      var _ref4$attrs = _ref4.attrs,
          email = _ref4$attrs.email,
          name = _ref4$attrs.name,
          jid = _ref4$attrs.jid;

      var _split = split(jid, '@'),
          _split2 = _slicedToArray(_split, 2),
          domain = _split2[1];

      return {
        id: jid,
        domain: domain,
        name: name,
        email: email
      };
    });
    return updateUsersInfo(usersInfo);
  }));
};

var requestChatHistoryEpic = function requestChatHistoryEpic(action$, state$, _ref5) {
  var xmpp = _ref5.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.RequestHistory), map(function (_ref6) {
    var jid = _ref6.payload.jid;
    xmpp.sendIQ({
      id: uuid(),
      to: jid,
      fields: {
        'chat-history': {
          tags: {
            xmlns: 'nextiva:iq:chat-history'
          }
        }
      }
    });
    return false;
  }), ignoreElements());
};

var processChatHistoryEpic = function processChatHistoryEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Talks.History), switchMap(function (_ref7) {
    var _ref7$payload = _ref7.payload,
        from = _ref7$payload.from,
        to = _ref7$payload.to,
        children = _ref7$payload.children;
    var chatHistoryElm = find(children, {
      name: 'chat-history'
    });
    var chatHistoryChildren = get(chatHistoryElm, 'children');
    var chatHistoryMessages = filter(chatHistoryChildren, {
      name: 'message'
    });
    var chatHistoryMetas = filter(chatHistoryChildren, {
      name: 'meta'
    });
    return concat.apply(void 0, _toConsumableArray(map$1(chatHistoryMetas, function (meta) {
      return of$1(Talks.Meta(_objectSpread2({
        to: to,
        from: from
      }, JSON.parse(get(meta, ['attrs', 'body'], '{}')))));
    })).concat(_toConsumableArray(map$1(chatHistoryMessages, function (child) {
      var messageChildren = get(child, 'children');
      var bodyElm = find(messageChildren, {
        name: 'body'
      });
      var content = JSON.parse(get(bodyElm, 'children[0]', '{}'));
      var transformedMessage = transformMessage(content);
      return of$1(Message.Chat(_objectSpread2({
        from: from,
        to: to
      }, transformedMessage)));
    }))));
  }));
};

var leaveChatEpic = function leaveChatEpic(action$, state$, _ref8) {
  var xmpp = _ref8.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.Leave), map(function (_ref9) {
    var jid = _ref9.payload.jid;
    var id = uuid();
    xmpp.sendIQ({
      id: id,
      to: jid,
      type: 'set',
      fields: {
        'leave-room': {
          tags: {
            xmlns: 'nextiva:iq:leave-room'
          }
        }
      }
    });
    return ResponsesWaiting.Add({
      id: id,
      action: Talks.Left,
      payload: {
        jid: jid
      }
    });
  }));
};

var leftChatEpic = function leftChatEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Talks.Left), withLatestFrom(state$), switchMap(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        jid = _ref11[0].payload.jid,
        isCustomer = _ref11[1].Chat.app.isCustomer;

    var events = [];

    if (isCustomer) {
      events.push(of$1(Talks.Remove({
        jid: jid
      })));
      events.push(of$1(Event.Output.Routing.NextStep()));
    }

    return concat.apply(void 0, events);
  }));
};

var releaseChatEpic = function releaseChatEpic(action$, state$, _ref12) {
  var xmpp = _ref12.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.Release), map(function (_ref13) {
    var jid = _ref13.payload.jid;
    var id = uuid();
    xmpp.sendIQ({
      id: id,
      to: jid,
      type: 'set',
      fields: {
        'chat-end': {
          tags: {
            xmlns: 'nextiva:iq:chat-end'
          }
        }
      }
    });
    return ResponsesWaiting.Add({
      id: id,
      action: Talks.Released,
      payload: {
        jid: jid
      }
    });
  }));
};

var saveChatEpic = function saveChatEpic(action$, state$, _ref14) {
  var xmpp = _ref14.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.Save), map(function (_ref15) {
    var _ref15$payload = _ref15.payload,
        jid = _ref15$payload.jid,
        description = _ref15$payload.description,
        links = _ref15$payload.links;
    var id = uuid();
    var fields = map$1(links, function (_ref16) {
      var linkID = _ref16.id,
          type = _ref16.type;
      return {
        'thread-relationship': {
          tags: {
            xmlns: 'nextiva:chat-save:thread-relationship',
            id: linkID,
            type: type
          }
        }
      };
    });
    var isJunk = !size(fields);
    var messageType = "chat-save".concat(isJunk ? '-junk' : '');
    xmpp.sendIQ({
      id: id,
      to: jid,
      type: 'set',
      fields: _defineProperty({}, messageType, {
        tags: {
          xmlns: "nextiva:iq:".concat(messageType),
          description: description
        },
        fields: fields
      })
    });
    return ResponsesWaiting.Add({
      id: id,
      action: Talks.Saved,
      payload: {
        jid: jid
      }
    });
  }));
};

var onSavedEpic = function onSavedEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Talks.Saved), withLatestFrom(state$), map(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        _ref18$0$payload = _ref18[0].payload,
        _ref18$0$payload$xml = _ref18$0$payload.xml,
        type = _ref18$0$payload$xml.attrs.type,
        children = _ref18$0$payload$xml.children,
        jid = _ref18$0$payload.jid,
        eventHandlers = _ref18[1].Chat.app.eventHandlers;

    var interactionID = get(children, '[0].attrs.interaction_id');

    if (type === 'result' && !!interactionID) {
      var savedHandlers = get(eventHandlers, ChatEvents.SaveChatSuccess);
      forEach(savedHandlers, function (h) {
        return h({
          interactionID: interactionID,
          jid: jid
        });
      });
    }

    return false;
  }), ignoreElements());
};

var TalksEpics = [requestChatParticipantsEpic, chatParticipantsEpic, requestChatHistoryEpic, processChatHistoryEpic, leaveChatEpic, leftChatEpic, releaseChatEpic, saveChatEpic, onSavedEpic];

var maybeAdditionalActions = function maybeAdditionalActions(messages) {
  return map$1(messages, function (_ref) {
    var _ref$body$payload = _ref.body.payload,
        type = _ref$body$payload.type,
        props = _objectWithoutProperties(_ref$body$payload, ["type"]);

    return get(Event.Input.Routing, camelCase(type), Event.Input.Routing.Unknown)(_objectSpread2({
      type: type
    }, props));
  });
};

var initTalk = function initTalk(jid) {
  return concat(of$1(Talks.Add({
    jid: jid
  })), of$1(Talks.RequestHistory({
    jid: jid
  })), of$1(Talks.RequestParticipants({
    jid: jid
  })));
};

var routingNextStepEpic = function routingNextStepEpic(action$, state$, _ref2) {
  var xmpp = _ref2.xmpp;
  return action$.pipe(ofType(ActionTypes.Event.Output.Routing.NextStep), withLatestFrom(state$), map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        payload = _ref4[0].payload,
        _ref4$1$Chat = _ref4[1].Chat,
        componentDomain = _ref4$1$Chat.app.XMPP.componentDomain,
        stepData = _ref4$1$Chat.routing.stepData;

    xmpp.sendIQ({
      id: uuid(),
      to: "routing.".concat(componentDomain),
      type: 'set',
      fields: {
        message: {
          fields: {
            body: JSON.stringify({
              created_at: getUtcIsoTimestamp(),
              sender: {},
              body: {
                text: '',
                payload: merge$1({
                  type: 'initial_message'
                }, payload || stepData)
              }
            })
          },
          tags: {
            xmlns: 'nextiva:routing:message'
          }
        }
      }
    });
    return false;
  }), ignoreElements());
};

var routingFlowEpic = function routingFlowEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Routing.Flow), mergeMap(function (_ref5) {
    var messages = _ref5.payload.messages;
    return maybeAdditionalActions(messages);
  }));
};

var routingRoomInvitationEpic = function routingRoomInvitationEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Routing.roomInvitation), switchMap(function (_ref6) {
    var jid = _ref6.payload.room_jid;
    return initTalk(jid);
  }));
};

var routingAgentInvitationEpic = function routingAgentInvitationEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Talks.Invitation.Request), withLatestFrom(state$), map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        invitation = _ref8[0].payload.invitation,
        eventHandlers = _ref8[1].Chat.app.eventHandlers;

    var type = get(invitation, ['body', 'payload', 'type']);
    var invitationUUID = get(invitation, ['body', 'payload', 'invitation_uuid']);

    if (type === Types.invitationDeclined) {
      var invitationCanceledHandlers = get(eventHandlers, ChatEvents.ChatInvitationCanceled);
      forEach(invitationCanceledHandlers, function (h) {
        return h({
          uuid: invitationUUID
        });
      });
    } else {
      var invitationHandlers = get(eventHandlers, ChatEvents.IncomingChat);
      forEach(invitationHandlers, function (h) {
        return h(_objectSpread2({
          uuid: invitationUUID
        }, get(invitation, ['body', 'payload', 'customer_data'], {})));
      });
    }

    return false;
  }), ignoreElements());
};

var routingAgentInvitationResponseEpic = function routingAgentInvitationResponseEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Routing.AgentInvitation), withLatestFrom(state$), switchMap(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        _ref10$0$payload$invi = _ref10[0].payload.invitation.body.payload,
        status = _ref10$0$payload$invi.status,
        jid = _ref10$0$payload$invi.room_jid,
        invitationUUID = _ref10$0$payload$invi.invitation_uuid,
        eventHandlers = _ref10[1].Chat.app.eventHandlers;

    if (status === 'rejected') {
      var _invitationHandlers = get(eventHandlers, ChatEvents.ChatRejected);

      forEach(_invitationHandlers, function (h) {
        return h({
          uuid: invitationUUID
        });
      }); // Works as noop!

      return concat();
    }

    var invitationHandlers = get(eventHandlers, ChatEvents.ChatAccepted);
    forEach(invitationHandlers, function (h) {
      return h({
        jid: jid,
        uuid: invitationUUID
      });
    });
    return initTalk(jid);
  }));
};

var routingTransferInvitationEpic = function routingTransferInvitationEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Message.TransferInvitation), withLatestFrom(state$), map(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        invitation = _ref12[0].payload.invitation,
        eventHandlers = _ref12[1].Chat.app.eventHandlers;

    var invitationHandlers = get(eventHandlers, ChatEvents.IncomingTransfer);
    forEach(invitationHandlers, function (h) {
      return h({
        uuid: get(invitation, ['transfer_uuid']),
        agent: get(invitation, ['from'], {}),
        isGroup: get(invitation, ['is_group_chat'], false),
        contact: get(invitation, ['customer']),
        message: get(invitation, ['message'])
      });
    });
    return false;
  }), ignoreElements());
};

var routingTransferInvitationResponseEpic = function routingTransferInvitationResponseEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Message.TransferInvitationResponse), withLatestFrom(state$), switchMap(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        _ref14$0$payload = _ref14[0].payload,
        transferUUID = _ref14$0$payload.uuid,
        action = _ref14$0$payload.action,
        from = _ref14$0$payload.from,
        transferJid = _ref14$0$payload.jid,
        _ref14$1$Chat = _ref14[1].Chat,
        me = _ref14$1$Chat.me,
        outgoingTransfers = _ref14$1$Chat.routing.outgoingTransfers,
        eventHandlers = _ref14$1$Chat.app.eventHandlers;

    if (me === from) {
      var invitation = find(outgoingTransfers, {
        transferUUID: transferUUID
      }) || {};
      var isGroupChat = invitation.is_group_chat,
          jid = invitation.room_jid,
          id = invitation.id;

      if (action === 'accept' && !isGroupChat) {
        return concat(of$1(Message.Chat({
          to: me,
          from: jid,
          timestamp: getUtcIsoTimestamp(),
          meta: {
            uuid: uuid()
          },
          type: Types.system,
          message: "You've left this chat"
        })), of$1(Event.Input.Routing.RemoveOutgoingTransfer({
          uuid: id
        })), of$1(Event.Input.Routing.LeaveRoom({
          uuid: jid
        })));
      }

      if (action === 'decline') {
        var declinedBy = get(invitation, ['to', 'name'], 'your colleague');
        return of$1(Event.Input.Routing.UpdateOutgoingTransfer({
          uuid: transferUUID,
          error: "Transfer Declined by ".concat(declinedBy)
        }));
      }
    } else {
      var transferHandlers = get(eventHandlers, ChatEvents.TransferAccepted);
      forEach(transferHandlers, function (h) {
        return h({
          jid: transferJid,
          uuid: transferUUID
        });
      });
      return of$1(Event.Input.Routing.roomInvitation({
        room_jid: transferJid
      }));
    } // Works as noop!


    return concat();
  }));
};

var routingTransferInvitationCanceledEpic = function routingTransferInvitationCanceledEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Routing.TransferInvitationCanceled), withLatestFrom(state$), switchMap(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        transferUUID = _ref16[0].payload.transferUUID,
        eventHandlers = _ref16[1].Chat.app.eventHandlers;

    var invitationHandlers = get(eventHandlers, ChatEvents.TransferDeclined);
    forEach(invitationHandlers, function (h) {
      return h({
        uuid: transferUUID
      });
    });
    return of$1(Event.Input.Routing.RemoveIncomingTransfer({
      uuid: transferUUID
    }));
  }));
};

var routingTransferInvitationExpiredEpic = function routingTransferInvitationExpiredEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Routing.TransferInvitationExpired), withLatestFrom(state$), switchMap(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        transferUUID = _ref18[0].payload.transferUUID,
        _ref18$1$Chat = _ref18[1].Chat,
        _ref18$1$Chat$routing = _ref18$1$Chat.routing,
        transferInvitations = _ref18$1$Chat$routing.transferInvitations,
        outgoingTransfers = _ref18$1$Chat$routing.outgoingTransfers,
        eventHandlers = _ref18$1$Chat.app.eventHandlers;

    var incomingTransfer = get(transferInvitations, transferUUID, null);
    var outgoingTransfer = find(outgoingTransfers, {
      transferUUID: transferUUID
    }) || null;

    if (incomingTransfer !== null) {
      var invitationHandlers = get(eventHandlers, ChatEvents.TransferDeclined);
      forEach(invitationHandlers, function (h) {
        return h({
          uuid: transferUUID
        });
      });
      return of$1(Event.Input.Routing.RemoveIncomingTransfer({
        uuid: transferUUID
      }));
    }

    if (outgoingTransfer !== null) {
      return of$1(Event.Input.Routing.UpdateOutgoingTransfer({
        uuid: transferUUID,
        error: 'Transfer invitation expired'
      }));
    }

    return concat();
  }));
};

var RoutingEpics = [routingNextStepEpic, routingFlowEpic, routingRoomInvitationEpic, routingAgentInvitationEpic, routingAgentInvitationResponseEpic, routingTransferInvitationEpic, routingTransferInvitationResponseEpic, routingTransferInvitationCanceledEpic, routingTransferInvitationExpiredEpic];

var status = (function (_ref) {
  var status = _ref.xml;
  return get(Status, capitalize(status), Status.Unknown)({
    status: status
  });
});

var common = (function (xml) {
  return Event.Input.Iq({
    xml: xml
  });
});

var parseMessage = function parseMessage(_ref) {
  var children = _ref.children;
  var body = find(children, {
    name: 'body'
  });
  var content = get(body, 'children[0]', '');
  return JSON.parse(content.replace(/&quot;/g, '"'));
};

var routing$1 = (function (_ref2) {
  var _ref2$attrs = _ref2.attrs,
      _ref2$attrs$from = _ref2$attrs.from,
      from = _ref2$attrs$from === void 0 ? '' : _ref2$attrs$from,
      to = _ref2$attrs.to,
      type = _ref2$attrs.type,
      id = _ref2$attrs.id,
      children = _ref2.children;

  if (type === 'result') {
    if (/routing/g.test(from)) {
      var messages = map$1(children, parseMessage);
      return Event.Input.Routing.Flow({
        from: from,
        messages: messages,
        to: to
      });
    }

    if (/initialization/g.test(from)) {
      if (children.length === 0) return false; // empty result when transfer is declined

      var message = find(children, {
        name: 'message'
      });
      var body = find(get(message, 'children'), {
        name: 'body'
      });
      var transferBody = JSON.parse(get(children, '[0].children[0].children[0]', '{}'));

      if (some(children, function (_ref3) {
        var name = _ref3.name;
        return name === 'transfer-accept';
      })) {
        var jid = transferBody.room_jid,
            transferUUID = transferBody.transfer_uuid;
        return Event.Input.Message.TransferInvitationResponse({
          jid: jid,
          from: from,
          action: 'accept',
          uuid: transferUUID
        });
      }

      if (some(children, function (_ref4) {
        var name = _ref4.name;
        return name === 'transfer-init';
      })) {
        var _transferUUID = transferBody.transfer_uuid;
        return Event.Input.Routing.TransferInit({
          id: id,
          transferUUID: _transferUUID
        });
      }

      if (!message || !body) return false;
      return Event.Input.Routing.AgentInvitation({
        invitation: JSON.parse(get(body, 'children[0]', '{}'))
      });
    }

    if (some(children, function (_ref5) {
      var name = _ref5.name;
      return name === 'chat-history';
    })) {
      return Talks.History({
        from: from,
        children: children,
        to: to
      });
    }

    if (some(children, function (_ref6) {
      var name = _ref6.name;
      return name === 'chat-participants';
    })) {
      return Talks.Participants({
        from: from,
        children: children,
        to: to
      });
    }
  }

  return false;
});

var maybeChatHistory = function maybeChatHistory(children, from, to) {
  var element = find(children, {
    name: 'chat-history'
  });

  if (!element) {
    return false;
  }

  return Event.Input.Routing.ChatHistory({
    from: from,
    to: to,
    children: get(element, 'children')
  });
};

var maybeChatParticipants = function maybeChatParticipants(children, from, to) {
  var element = find(children, {
    name: 'chat-participants'
  });

  if (!element) {
    return false;
  }

  return Event.Input.Routing.ChatParticipants({
    from: from,
    to: to,
    children: get(element, 'children')
  });
};

var maybeChatInitialization = function maybeChatInitialization(children, from) {
  if (!/initialization/g.test(from)) {
    return false;
  }

  var message = find(children, {
    name: 'message'
  });
  var body = find(get(message, 'children'), {
    name: 'body'
  });
  var transferInit = find(children, {
    name: 'transfer-init'
  });
  if (transferInit || !body) return false;
  return Event.Input.Routing.AgentInvitation({
    invitation: JSON.parse(get(body, 'children[0]', '{}'))
  });
};

var chat = (function (xml) {
  var _xml$attrs = xml.attrs,
      _xml$attrs$from = _xml$attrs.from,
      from = _xml$attrs$from === void 0 ? '' : _xml$attrs$from,
      to = _xml$attrs.to,
      type = _xml$attrs.type,
      children = xml.children;

  if (type !== 'result') {
    return false;
  }

  return reduce([maybeChatHistory, maybeChatParticipants, maybeChatInitialization], function (acc, fn) {
    return acc || fn(children, from, to);
  }, false);
});

var settings = (function (_ref) {
  var _ref$attrs = _ref.attrs,
      from = _ref$attrs.from,
      type = _ref$attrs.type,
      children = _ref.children;

  if (type === 'error') {
    return false;
  }

  if (/builder/i.test(from)) {
    var settingsElm = find(children, {
      name: 'settings'
    });
    var bodyElm = find(get(settingsElm, 'children'), {
      name: 'body'
    });
    var settings = JSON.parse(get(bodyElm, 'children[0]'));
    return Settings.Response(settings);
  }

  return false;
});

var roster = (function (_ref) {
  var type = _ref.attrs.type,
      children = _ref.children;

  if (type === 'result') {
    var rosterQuery = find(children, function (_ref2) {
      var name = _ref2.name,
          xmlns = _ref2.attrs.xmlns;
      return name === 'query' && xmlns === 'jabber:iq:roster';
    });

    if (rosterQuery) {
      var rosterVersion = get(rosterQuery, ['attrs', 'ver']);
      var rosterItems = get(rosterQuery, 'children');
      var items = reduce(rosterItems, function (acc, _ref3) {
        var name = _ref3.name,
            attrs = _ref3.attrs,
            rosterItemChildren = _ref3.children;
        if (name !== 'item') return acc;
        var itemJID = get(attrs, 'jid');
        var groupREResult = /(.*)@group/i.exec(itemJID);
        var itemName = get(attrs, 'name');
        var groupElements = filter(rosterItemChildren, {
          name: 'group'
        });
        var groups = map$1(groupElements, function (_ref4) {
          var groupChildren = _ref4.children;
          return get(groupChildren, '[0]');
        });
        var itemType = groupREResult ? RosterConstants.Entities.Group : RosterConstants.Entities.Contact;
        var itemID = get(groupREResult, '[1]');
        return [].concat(_toConsumableArray(acc), [{
          type: itemType,
          jid: itemID || itemJID,
          name: itemName,
          groups: groups
        }]);
      }, []);
      return Roster.Response({
        version: rosterVersion,
        items: items
      });
    }
  }

  return false;
});

var ParsersChain = [routing$1, chat, settings, roster, common];
var iq = (function (xml) {
  return reduce(ParsersChain, function (acc, fn) {
    return acc || fn(xml);
  }, false);
});

var chat$1 = (function (_ref) {
  var _ref$attrs = _ref.attrs,
      from = _ref$attrs.from,
      to = _ref$attrs.to,
      children = _ref.children;
  var bodyElm = find(children, {
    name: 'body'
  });
  var content = JSON.parse(get(bodyElm, 'children[0]', '{}'));
  var transformedMessage = transformMessage(content);
  var events = [Message.Chat(_objectSpread2({
    from: from,
    to: to
  }, transformedMessage))];

  if (transformedMessage.type === Types.transferAccepted || transformedMessage.type === Types.transferExpired || transformedMessage.type === Types.transferDeclined) {
    var _transformedMessage$m = transformedMessage.message,
        uuid = _transformedMessage$m.transfer_uuid,
        action = _transformedMessage$m.action,
        jid = _transformedMessage$m.from.jid;
    events.push(Event.Input.Message.TransferInvitationResponse({
      uuid: uuid,
      action: action,
      from: jid
    }));
  }

  if (transformedMessage.type === Types.transferInitialized) {
    var _uuid = content.uuid;
    events.push(Event.Input.Message.TransferInitiated(_objectSpread2({
      uuid: _uuid
    }, transformedMessage.message)));
  }

  if (transformedMessage.type === Types.chatEnded) {
    events.push(Talks.Released({
      jid: from
    }));
  }

  return events;
});

var invitation = (function (_ref) {
  var from = _ref.attrs.from,
      children = _ref.children;

  if (/initialization/g.test(from)) {
    var body = find(children, {
      name: 'body'
    });
    var invitation = JSON.parse(get(body, 'children[0]', {}));
    var type = get(invitation, 'type');
    var payload = get(invitation, ['body', 'payload']);
    if (type === Types.transferInit) return Event.Input.Message.TransferInvitation({
      invitation: invitation
    });

    if (payload.type === Types.transferExpired) {
      var transferUUID = get(payload, 'transfer_uuid');
      return Event.Input.Routing.TransferInvitationExpired({
        transferUUID: transferUUID
      });
    }

    if (payload.type === Types.transferDeclined) return Event.Input.Routing.TransferInvitationCanceled({
      transferUUID: payload.transfer_uuid
    });
    return Talks.Invitation.Request({
      invitation: invitation
    });
  }

  return false;
});

var ParsersChain$1 = [invitation, chat$1];
var message$1 = (function (xml) {
  return reduce(ParsersChain$1, function (acc, fn) {
    return acc || fn(xml);
  }, false);
});

var presence = (function (_ref) {
  var _ref$attrs = _ref.attrs,
      from = _ref$attrs.from,
      type = _ref$attrs.type;

  var _split = split(from, '/'),
      _split2 = _slicedToArray(_split, 1),
      fromBareJID = _split2[0];

  return Event.Input.Presence({
    type: !type ? UserStatuses.Online : UserStatuses.Offline,
    from: fromBareJID
  });
});

var MessageHandlers = {
  iq: iq,
  message: message$1,
  presence: presence
};
var input = (function (_ref) {
  var xml = _ref.xml;
  var messageType = get(xml, 'name');
  return get(MessageHandlers, messageType, Event.Input.Unsuported)(xml);
});

var message$2 = (function (_ref) {
  var _ref$attrs = _ref.attrs,
      to = _ref$attrs.to,
      uuid = _ref$attrs.uuid;
  return Message.Sent({
    to: to,
    uuid: uuid
  });
});

var presence$1 = (function (payload) {
  return Presence.Sent(payload);
});

var MessageHandlers$1 = {
  message: message$2,
  presence: presence$1
};
var output = (function (_ref) {
  var xml = _ref.xml;
  var messageType = get(xml, 'name');
  return get(MessageHandlers$1, messageType, Event.Output.Unsuported)(xml);
});

var TypeHandlers = {
  status: status,
  input: input,
  output: output
};

var responsesCheck = function responsesCheck(xml) {
  return ResponsesWaiting.Check({
    id: get(xml, ['attrs', 'id']),
    xml: xml
  });
};

var processor = (function (_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  var xml = parseXML(payload);
  var eventData = xml || payload;
  var chainResponses = get(TypeHandlers, type, Event.Unknown)({
    type: type,
    xml: eventData
  });
  var events = [];
  var isPing = get(eventData, 'children[0].name') === 'ping';

  if (!isPing) {
    if (isArray$1(chainResponses)) {
      forEach(chainResponses, function (event) {
        return events.push(event);
      });
    } else {
      events.push(chainResponses);
    }
  }

  if (type === 'input') {
    events.push(responsesCheck(xml));
  }

  if (type === 'stanza' && !isPing) {
    events.push(responsesCheck(payload));
  }

  return concat.apply(void 0, _toConsumableArray(map$1(events, function (event) {
    return of$1(event);
  })));
});

var backendEventsProcessorEppic = function backendEventsProcessorEppic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.InitEventHandler), switchMap(function () {
    return fromEventPattern(function (handler) {
      return xmpp.onMessage(handler);
    });
  }), switchMap(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        payload = _ref3[1];

    return processor(payload);
  }));
};

var BackendEpic = [backendEventsProcessorEppic];

var presenceSendEpic = function presenceSendEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Presence.Send), map(function (_ref2) {
    var _ref2$payload$presenc = _ref2.payload.presence,
        presence = _ref2$payload$presenc === void 0 ? true : _ref2$payload$presenc;
    var presenceToSend = presence ? 'available' : 'unavailable';
    xmpp.sendPresence(presenceToSend);
    return true;
  }), ignoreElements());
};

var presenceUpdateEpic = function presenceUpdateEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.Event.Input.Presence), withLatestFrom(state$), map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        _ref4$0$payload = _ref4[0].payload,
        from = _ref4$0$payload.from,
        type = _ref4$0$payload.type,
        users = _ref4[1].Chat.users;

    return (// TODO: User info processing should be reviewed
      updateUsersInfo([_objectSpread2({
        id: from
      }, users[from], {
        status: {
          label: type,
          value: type
        }
      })])
    );
  }));
};

var PresenceEpic = [presenceSendEpic, presenceUpdateEpic];

var processMessageEpic = function processMessageEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Message.Send), withLatestFrom(state$), map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        _ref3$0$payload = _ref3[0].payload,
        to = _ref3$0$payload.to,
        message = _ref3$0$payload.message,
        state = _ref3[1];

    var UUID = uuid();
    var activeUserJID = get(state, ['Chat', 'me']);
    var userData = omit(get(state, ['Chat', 'users', activeUserJID]), 'meta');
    var timestamp = getUtcIsoTimestamp();

    if (message) {
      xmpp.send({
        to: to,
        message: message,
        type: 'normal',
        fields: {
          body: JSON.stringify({
            uuid: UUID,
            created_at: timestamp,
            sender: userData,
            body: {
              text: message,
              payload: {}
            }
          })
        },
        tags: {
          uuid: UUID
        }
      });
    }

    return Message.Sending({
      uuid: UUID,
      to: to,
      message: message,
      from: activeUserJID
    });
  }));
};

var onIncomingMessageEpic = function onIncomingMessageEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Message.Chat), switchMap(function (_ref4) {
    var payload = _ref4.payload;
    var events = [];
    var children = get(payload, ['xml', 'children']);
    var newParticipantBody = find(children, {
      name: 'body'
    });
    var newParticipantData = JSON.parse(get(newParticipantBody, 'children[0]', '{}'));
    var participantPayload = get(newParticipantData, ['body', 'payload']);

    if (get(participantPayload, 'type') === Types.newParticipant) {
      var payloadData = get(participantPayload, 'data');
      events.push(updateUsersInfo([_objectSpread2({
        id: get(payloadData, 'jid')
      }, omit(payloadData, 'jid'))]));
    }

    return concat(events);
  }));
};

var sendInvitationEpic = function sendInvitationEpic(action$, state$, _ref5) {
  var xmpp = _ref5.xmpp;
  return action$.pipe(ofType(ActionTypes.Talks.Invitation.Response), withLatestFrom(state$), map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        _ref7$0$payload = _ref7[0].payload,
        uuid$1 = _ref7$0$payload.uuid,
        response = _ref7$0$payload.response,
        _ref7$1$Chat$app = _ref7[1].Chat.app,
        componentDomain = _ref7$1$Chat$app.XMPP.componentDomain,
        eventHandlers = _ref7$1$Chat$app.eventHandlers;

    xmpp.sendIQ({
      id: uuid(),
      to: "initialization.".concat(componentDomain),
      type: 'set',
      fields: {
        message: {
          tags: {
            xmlns: 'nextiva:invitation:message'
          },
          fields: {
            body: JSON.stringify({
              body: {
                payload: {
                  type: "invitation_".concat(response),
                  invitation_uuid: uuid$1
                }
              }
            })
          }
        }
      }
    });

    if (response === 'rejected') {
      var invitationHandlers = get(eventHandlers, ChatEvents.ChatDismissed);
      forEach(invitationHandlers, function (h) {
        return h({
          uuid: uuid$1
        });
      });
    }

    return false;
  }), ignoreElements());
};

var sendTransferInvitationEpic = function sendTransferInvitationEpic(action$, state$, _ref8) {
  var xmpp = _ref8.xmpp;
  return action$.pipe(ofType(ActionTypes.Event.Output.Message.TransferInvitation), withLatestFrom(state$), switchMap(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        payload = _ref10[0].payload,
        componentDomain = _ref10[1].Chat.app.XMPP.componentDomain;

    var id = uuid();
    xmpp.sendIQ({
      id: id,
      to: "initialization.".concat(componentDomain),
      from: payload.from.jid,
      type: 'set',
      fields: {
        'transfer-init': {
          tags: {
            xmlns: 'nextiva:transfer:init'
          },
          fields: {
            body: JSON.stringify(_objectSpread2({
              type: 'transfer_init'
            }, payload))
          }
        }
      }
    });
    return of$1(Event.Output.Routing.OutgoingTransfer(_objectSpread2({
      id: id
    }, payload)));
  }));
};

var sendTransferInvitationResponseEpic = function sendTransferInvitationResponseEpic(action$, state$, _ref11) {
  var xmpp = _ref11.xmpp;
  return action$.pipe(ofType(ActionTypes.Event.Output.Message.TransferInvitationResponse), withLatestFrom(state$), map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        _ref13$0$payload = _ref13[0].payload,
        uuid$1 = _ref13$0$payload.uuid,
        response = _ref13$0$payload.response,
        _ref13$1$Chat$app = _ref13[1].Chat.app,
        componentDomain = _ref13$1$Chat$app.XMPP.componentDomain,
        eventHandlers = _ref13$1$Chat$app.eventHandlers;

    xmpp.sendIQ({
      id: uuid(),
      to: "initialization.".concat(componentDomain),
      type: 'set',
      fields: _defineProperty({}, "transfer-".concat(response), {
        tags: {
          xmlns: "nextiva:transfer:".concat(response)
        },
        fields: {
          body: JSON.stringify({
            transfer_uuid: uuid$1
          })
        }
      })
    });

    if (response === 'decline') {
      var transferHandlers = get(eventHandlers, ChatEvents.TransferDeclined);
      forEach(transferHandlers, function (h) {
        return h({
          uuid: uuid$1
        });
      });
    }

    return false;
  }), ignoreElements());
};

var sendTransferInvitationCancelEpic = function sendTransferInvitationCancelEpic(action$, state$, _ref14) {
  var xmpp = _ref14.xmpp;
  return action$.pipe(ofType(ActionTypes.Event.Output.Message.TransferInvitationCancel), withLatestFrom(state$), map(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        uuid$1 = _ref16[0].payload.uuid,
        componentDomain = _ref16[1].Chat.app.XMPP.componentDomain;

    if (uuid$1) {
      xmpp.sendIQ({
        id: uuid(),
        to: "initialization.".concat(componentDomain),
        type: 'set',
        fields: {
          'transfer-decline': {
            tags: {
              xmlns: 'nextiva:transfer:decline'
            },
            fields: {
              body: JSON.stringify({
                transfer_uuid: uuid$1
              })
            }
          }
        }
      });
    }

    return false;
  }), ignoreElements());
};

var MessageEpics = [onIncomingMessageEpic, processMessageEpic, sendInvitationEpic, sendTransferInvitationEpic, sendTransferInvitationCancelEpic, sendTransferInvitationResponseEpic];

var responsesCheckEpic = function responsesCheckEpic(action$, state$) {
  return action$.pipe(ofType(ActionTypes.ResponsesWaiting.Check), withLatestFrom(state$), switchMap(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ref2$0$payload = _ref2[0].payload,
        id = _ref2$0$payload.id,
        xml = _ref2$0$payload.xml,
        responsesWaitingQueue = _ref2[1].Chat.responsesWaitingQueue;

    var events = [];

    if (has(responsesWaitingQueue, id)) {
      var _get = get(responsesWaitingQueue, id, {}),
          action = _get.action,
          _get$payload = _get.payload,
          payload = _get$payload === void 0 ? {} : _get$payload;

      if (isFunction$1(action)) {
        events.push(of$1(action(_objectSpread2({}, payload, {
          xml: xml
        }))));
      }

      events.push(of$1(ResponsesWaiting.Remove({
        id: id
      })));
    }

    return concat.apply(void 0, events);
  }));
};

var ResponseEpic = [responsesCheckEpic];

var requestSettingsEpic = function requestSettingsEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Settings.Request), withLatestFrom(state$), map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        _ref3$1$Chat$app = _ref3[1].Chat.app,
        isCustomer = _ref3$1$Chat$app.isCustomer,
        componentDomain = _ref3$1$Chat$app.XMPP.componentDomain;

    if (isCustomer) {
      xmpp.sendIQ({
        id: uuid(),
        to: "builder.".concat(componentDomain),
        type: 'set',
        fields: {
          settings: {
            tags: {
              xmlns: 'nextiva:builder:queue:settings'
            }
          }
        }
      });
    }

    return false;
  }), ignoreElements());
};

var SettingEpic = [requestSettingsEpic];

var rosterRequestEpic = function rosterRequestEpic(action$, state$, _ref) {
  var xmpp = _ref.xmpp;
  return action$.pipe(ofType(ActionTypes.Roster.Request), map(function () {
    xmpp.sendIQ({
      id: uuid(),
      type: 'get',
      fields: {
        query: {
          tags: {
            xmlns: 'jabber:iq:roster',
            ver: ''
          }
        }
      }
    });
    return true;
  }), ignoreElements());
};

var rosterResponseEpic = function rosterResponseEpic(action$) {
  return action$.pipe(ofType(ActionTypes.Roster.Response), switchMap(function (_ref2) {
    var items = _ref2.payload.items;
    var sorted = reduce(items, function (acc, item) {
      if (item.type === 'contact') {
        var _split = split(item.jid, '@'),
            _split2 = _slicedToArray(_split, 2),
            username = _split2[0],
            domain = _split2[1];

        return _objectSpread2({}, acc, {
          contacts: [].concat(_toConsumableArray(acc.contacts), [_objectSpread2({
            id: item.jid,
            username: username,
            domain: domain
          }, item)])
        });
      }

      return _objectSpread2({}, acc, {
        groups: [].concat(_toConsumableArray(acc.groups), [item])
      });
    }, {
      contacts: [],
      groups: []
    });
    return concat(of$1(updateGroupsInfo(sorted.groups)), of$1(updateUsersInfo(sorted.contacts)));
  }));
};

var RosterEpic = [rosterRequestEpic, rosterResponseEpic];

var chatEpic = combineEpics.apply(void 0, _toConsumableArray(ConnectEpics).concat(_toConsumableArray(AgentAuthenticationEpics), _toConsumableArray(TalksEpics), _toConsumableArray(RoutingEpics), _toConsumableArray(MessageEpics), _toConsumableArray(BackendEpic), _toConsumableArray(PresenceEpic), _toConsumableArray(ResponseEpic), _toConsumableArray(SettingEpic), _toConsumableArray(RosterEpic)));

var epics = combineEpics(chatEpic);

var _ActionTypes$UpdateCo;
var AppReducers = (_ActionTypes$UpdateCo = {}, _defineProperty(_ActionTypes$UpdateCo, ActionTypes.UpdateConnectionProps, function (state, _ref) {
  var _ref$payload = _ref.payload,
      protocol = _ref$payload.protocol,
      host = _ref$payload.host,
      endpoint = _ref$payload.endpoint;
  var newState = cloneDeep(state);
  var existingXMPP = get(newState, ['app', 'XMPP'], {});
  set(newState, ['app', 'XMPP'], _objectSpread2({}, existingXMPP, {
    protocol: protocol,
    host: host,
    endpoint: endpoint
  }));
  return newState;
}), _defineProperty(_ActionTypes$UpdateCo, ActionTypes.AddEventHandler, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      event = _ref2$payload.event,
      handler = _ref2$payload.handler;
  var newState = cloneDeep(state);
  var existingHandlers = get(newState, ['app', 'eventHandlers', event], []);
  existingHandlers.push(handler);
  set(newState, ['app', 'eventHandlers', event], existingHandlers);
  return newState;
}), _defineProperty(_ActionTypes$UpdateCo, ActionTypes.RemoveEventHandler, function (state, _ref3) {
  var _ref3$payload = _ref3.payload,
      event = _ref3$payload.event,
      handler = _ref3$payload.handler;
  var newState = cloneDeep(state);
  var existingHandlers = get(newState, ['app', 'eventHandlers', event], []);
  set(newState, ['app', 'eventHandlers', event], remove(existingHandlers, function (eHandler) {
    return eHandler === handler;
  }));
  return newState;
}), _defineProperty(_ActionTypes$UpdateCo, ActionTypes.IsCustomer, function (state) {
  var newState = cloneDeep(state);
  set(newState, ['app', 'isCustomer'], true);
  return newState;
}), _defineProperty(_ActionTypes$UpdateCo, ActionTypes.UpdateAppStatus, function (state, _ref4) {
  var _ref4$payload = _ref4.payload,
      parameter = _ref4$payload.parameter,
      value = _ref4$payload.value;
  var newState = cloneDeep(state);
  var existingStatuses = get(newState, ['app', 'statuses']);
  set(newState, ['app', 'statuses'], _objectSpread2({}, existingStatuses, _defineProperty({}, parameter, value)));
  return newState;
}), _ActionTypes$UpdateCo);

var _ActionTypes$Status$O;
var UsersReducers = (_ActionTypes$Status$O = {}, _defineProperty(_ActionTypes$Status$O, ActionTypes.Status.Online, function (state) {
  var newState = cloneDeep(state);
  return set(newState, ['users', get(state, 'me'), 'meta', 'status'], find(newState.statuses, {
    value: UserStatuses.Online
  }));
}), _defineProperty(_ActionTypes$Status$O, ActionTypes.UpdateUsersInfo, function (state, _ref) {
  var payload = _ref.payload;
  var newState = cloneDeep(state);
  forEach(payload, function (_ref2) {
    var token = _ref2.token,
        corpAccountNumber = _ref2.corpAccountNumber,
        id = _ref2.id,
        jid = _ref2.jid,
        username = _ref2.username,
        name = _ref2.name,
        domain = _ref2.domain,
        status = _ref2.status,
        groups = _ref2.groups,
        additional = _ref2.additional,
        rest = _objectWithoutProperties(_ref2, ["token", "corpAccountNumber", "id", "jid", "username", "name", "domain", "status", "groups", "additional"]);

    var _split = split(username, '~~'),
        _split2 = _slicedToArray(_split, 2),
        usernameID = _split2[1];

    var userID = id || usernameID;
    var me = get(newState, 'me') || userID;
    var defaultStatus = find(newState.statuses, {
      value: 'offline'
    });
    var existingStatus = get(newState, ['users', userID, 'meta', 'status'], defaultStatus);
    var existingToken = get(newState, ['users', userID, 'meta', 'token'], '');
    var existingGroups = get(newState, ['users', userID, 'meta', 'groups'], []);
    var existingCorpAcc = get(newState, ['users', userID, 'meta', 'corpAccountNumber'], '');
    var newStatus = status || existingStatus || jid;
    var newToken = token || existingToken;
    var newGroups = groups || existingGroups;
    var newCorpAcc = corpAccountNumber || existingCorpAcc;
    set(newState, ['users', userID, 'id'], userID);
    set(newState, ['users', userID, 'name'], name);
    set(newState, ['users', userID, 'username'], usernameID);
    set(newState, ['users', userID, 'domain'], domain);
    set(newState, ['users', userID, 'additional'], _objectSpread2({}, additional, {}, rest));
    set(newState, ['users', userID, 'meta', 'status'], newStatus);
    set(newState, ['users', userID, 'meta', 'token'], newToken);
    set(newState, ['users', userID, 'meta', 'groups'], newGroups);
    set(newState, ['users', userID, 'meta', 'corpAccountNumber'], newCorpAcc);
    set(newState, 'me', me);
  });
  return newState;
}), _ActionTypes$Status$O);

var GroupsReducers = _defineProperty({}, ActionTypes.UpdateGroupsInfo, function (state, _ref) {
  var payload = _ref.payload;
  var newState = cloneDeep(state);
  forEach(payload, function (_ref2) {
    var jid = _ref2.jid,
        name = _ref2.name,
        rest = _objectWithoutProperties(_ref2, ["jid", "name"]);

    set(newState, ['groups', jid, 'id'], jid);
    set(newState, ['groups', jid, 'name'], name);
    set(newState, ['groups', jid, 'additional'], rest);
  });
  return newState;
});

var _ActionTypes$Message$;

var updateMessages = function updateMessages(state, to, message$1) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Types$1.Text;
  var meta = arguments.length > 4 ? arguments[4] : undefined;
  var status = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Statuses.Sending;
  var uuid = get(meta, 'uuid');

  if (uuid) {
    var existingMeta = get(state, ['messages', to, uuid, 'meta'], {});
    var from = get(meta, 'from'); // The order is _important_. Previous properties could be rewritten.

    set(state, ['messages', to, uuid], {
      payload: {
        type: type,
        content: message$1
      },
      meta: _objectSpread2({
        sender: {
          id: from
        },
        timestamp: getUtcIsoTimestamp()
      }, meta, {}, existingMeta, {
        status: status
      })
    });
  }

  return state;
};

var MessageReducers = (_ActionTypes$Message$ = {}, _defineProperty(_ActionTypes$Message$, ActionTypes.Message.Sending, function (state, _ref) {
  var _ref$payload = _ref.payload,
      message = _ref$payload.message,
      to = _ref$payload.to,
      meta = _objectWithoutProperties(_ref$payload, ["message", "to"]);

  return updateMessages(state, to, message, _objectSpread2({
    to: to
  }, meta));
}), _defineProperty(_ActionTypes$Message$, ActionTypes.Message.Sent, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      to = _ref2$payload.to,
      uuid = _ref2$payload.uuid;
  var newState = cloneDeep(state);
  set(state, ['messages', to, uuid, 'meta', 'status'], Statuses.Sent);
  return newState;
}), _defineProperty(_ActionTypes$Message$, ActionTypes.Message.Chat, function (state, _ref3) {
  var _ref3$payload = _ref3.payload,
      from = _ref3$payload.from,
      to = _ref3$payload.to,
      type = _ref3$payload.type,
      timestamp = _ref3$payload.timestamp,
      message = _ref3$payload.message,
      meta = _ref3$payload.meta;
  var newState = cloneDeep(state);
  return updateMessages(newState, from, message, type, _objectSpread2({
    to: to,
    from: from,
    timestamp: timestamp
  }, meta));
}), _ActionTypes$Message$);

var _ActionTypes$Event$In;
var RoutingReducers = (_ActionTypes$Event$In = {}, _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.Flow, function (state, _ref) {
  var _ref$payload$messages = _ref.payload.messages,
      messages = _ref$payload$messages === void 0 ? [] : _ref$payload$messages;
  var newState = cloneDeep(state);
  set(newState, ['routing', 'currentStep'], messages[1] || {});
  set(newState, ['routing', 'stepData'], {});
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.formError, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      fields = _ref2$payload.fields,
      type = _ref2$payload.type,
      errors = _ref2$payload.errors;
  var newState = cloneDeep(state);
  set(newState, ['routing', 'currentStep'], {
    created_at: getUtcIsoTimestamp(),
    body: {
      payload: {
        type: type,
        fields: fields,
        errors: errors
      }
    }
  });
  set(newState, ['routing', 'stepData'], {});
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.schedule, function (state, _ref3) {
  var _ref3$payload = _ref3.payload,
      conditions = _ref3$payload.conditions,
      timezone = _ref3$payload.timezone,
      type = _ref3$payload.type;
  var newState = cloneDeep(state);
  set(newState, ['routing', 'currentStep'], {
    body: {
      payload: {
        type: type,
        conditions: conditions,
        timezone: timezone,
        workingHours: transformScheduling(conditions, timezone)
      }
    },
    created_at: getUtcIsoTimestamp()
  });
  set(newState, ['routing', 'stepData'], {});
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.UpdateRoutingStepData, function (state, _ref4) {
  var payload = _ref4.payload;
  var newState = cloneDeep(state);
  var existingOpts = get(newState, ['routing', 'stepData'], {});
  set(newState, ['routing', 'stepData'], _objectSpread2({}, existingOpts, {}, payload));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Talks.Invitation.Request, function (state, _ref5) {
  var payload = _ref5.payload.invitation.body.payload;
  var newState = cloneDeep(state);
  var type = get(payload, 'type');

  if (type === Types.invitationDeclined) {
    var existingInvitations = get(newState, ['routing', 'invitations'], {});
    var uuid = get(payload, 'uuid');
    set(newState, ['routing', 'invitations'], omit(existingInvitations, uuid));
    return newState;
  }

  set(newState, ['routing', 'invitations', get(payload, 'invitation_uuid')], payload);
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Talks.Invitation.Response, function (state, _ref6) {
  var uuid = _ref6.payload.uuid;
  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'invitations'], {});
  set(newState, ['routing', 'invitations'], omit(existingInvitations, uuid));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Output.Routing.OutgoingTransfer, function (state, _ref7) {
  var _ref7$payload = _ref7.payload,
      id = _ref7$payload.id,
      rest = _objectWithoutProperties(_ref7$payload, ["id"]);

  var newState = cloneDeep(state);
  set(newState, ['routing', 'outgoingTransfers', id], _objectSpread2({
    id: id
  }, rest));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.TransferInit, function (state, _ref8) {
  var _ref8$payload = _ref8.payload,
      id = _ref8$payload.id,
      transferUUID = _ref8$payload.transferUUID;
  var newState = cloneDeep(state);
  var invitation = get(newState, ['routing', 'outgoingTransfers', id]);
  set(newState, ['routing', 'outgoingTransfers', id], _objectSpread2({}, invitation, {
    transferUUID: transferUUID
  }));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Message.TransferInvitation, function (state, _ref9) {
  var _ref9$payload$invitat = _ref9.payload.invitation,
      agent = _ref9$payload$invitat.from,
      isGroup = _ref9$payload$invitat.is_group_chat,
      message = _ref9$payload$invitat.message,
      uuid = _ref9$payload$invitat.transfer_uuid,
      roomJid = _ref9$payload$invitat.room_jid,
      contact = _ref9$payload$invitat.customer,
      startedAt = _ref9$payload$invitat.started_at,
      countdown = _ref9$payload$invitat.transfer_lifetime,
      rest = _objectWithoutProperties(_ref9$payload$invitat, ["from", "is_group_chat", "message", "transfer_uuid", "room_jid", "customer", "started_at", "transfer_lifetime"]);

  var newState = cloneDeep(state);
  set(newState, ['routing', 'transferInvitations', uuid], _objectSpread2({
    agent: agent,
    isGroup: isGroup,
    message: message,
    uuid: uuid,
    roomJid: roomJid,
    contact: contact,
    startedAt: startedAt,
    countdown: countdown
  }, rest));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.RemoveOutgoingTransfer, function (state, _ref10) {
  var uuid = _ref10.payload.uuid;
  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'outgoingTransfers'], {});
  set(newState, ['routing', 'outgoingTransfers'], omit(existingInvitations, uuid));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.UpdateOutgoingTransfer, function (state, _ref11) {
  var _ref11$payload = _ref11.payload,
      uuid = _ref11$payload.uuid,
      error = _ref11$payload.error,
      rest = _objectWithoutProperties(_ref11$payload, ["uuid", "error"]);

  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'outgoingTransfers'], {});
  var invitation = find(existingInvitations, {
    transferUUID: uuid
  }) || null;
  if (invitation === null) return newState;
  set(newState, ['routing', 'outgoingTransfers', invitation.id], _objectSpread2({}, invitation, {
    error: error
  }, rest));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.RemoveIncomingTransfer, function (state, _ref12) {
  var uuid = _ref12.payload.uuid;
  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'transferInvitations'], {});
  set(newState, ['routing', 'transferInvitations'], omit(existingInvitations, uuid));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Input.Routing.LeaveRoom, function (state, _ref13) {
  var uuid = _ref13.payload.uuid;
  var newState = cloneDeep(state);
  var existingChat = get(newState, ['chats', uuid], {});
  set(newState, ['chats', uuid], _objectSpread2({}, existingChat, {
    disabledInput: true
  }));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Output.Message.TransferInvitationResponse, function (state, _ref14) {
  var uuid = _ref14.payload.uuid;
  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'transferInvitations'], {});
  set(newState, ['routing', 'transferInvitations'], omit(existingInvitations, uuid));
  return newState;
}), _defineProperty(_ActionTypes$Event$In, ActionTypes.Event.Output.Message.TransferInvitationCancel, function (state, _ref15) {
  var id = _ref15.payload.id;
  var newState = cloneDeep(state);
  var existingInvitations = get(newState, ['routing', 'outgoingTransfers'], {});
  set(newState, ['routing', 'outgoingTransfers'], omit(existingInvitations, id));
  return newState;
}), _ActionTypes$Event$In);

var _ActionTypes$Talks$Ad;
var TalksReducers = (_ActionTypes$Talks$Ad = {}, _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.Add, function (state, _ref) {
  var jid = _ref.payload.jid;
  var newState = cloneDeep(state);
  set(newState, ['messages', jid], {});
  set(newState, ['chats', jid], {
    id: jid,
    released: false
  });
  return newState;
}), _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.Remove, function (state, _ref2) {
  var jid = _ref2.payload.jid;
  var newState = cloneDeep(state);
  var existingMessages = get(newState, 'messages', {});
  var existingChats = get(newState, 'chats', {});
  set(newState, 'messages', omit(existingMessages, jid));
  set(newState, 'chats', omit(existingChats, jid));
  set(newState, ['routing', 'formMessages'], []);
  return newState;
}), _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.Released, function (state, _ref3) {
  var jid = _ref3.payload.jid;
  var newState = cloneDeep(state);
  set(newState, ['chats', jid, 'released'], true);
  return newState;
}), _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.Meta, function (state, _ref4) {
  var _ref4$payload = _ref4.payload,
      from = _ref4$payload.from,
      messages = _ref4$payload.messages;
  var newState = cloneDeep(state);
  var formResult = transformFormResult(messages);
  var existingFormMessages = get(newState, ['routing', 'formMessages', from], []);
  set(newState, ['routing', 'formMessages', from], [].concat(_toConsumableArray(existingFormMessages), [formResult]));
  return newState;
}), _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.UpdateDescription, function (state, _ref5) {
  var _ref5$payload = _ref5.payload,
      jid = _ref5$payload.jid,
      description = _ref5$payload.description;
  var newState = cloneDeep(state);
  set(newState, ['chats', jid, 'description'], description);
  return newState;
}), _defineProperty(_ActionTypes$Talks$Ad, ActionTypes.Talks.UpdateInputMessage, function (state, _ref6) {
  var _ref6$payload = _ref6.payload,
      jid = _ref6$payload.jid,
      message = _ref6$payload.message;
  var newState = cloneDeep(state);
  set(newState, ['chats', jid, 'message'], message);
  return newState;
}), _ActionTypes$Talks$Ad);

var _ActionTypes$Response;
var ResponsesWaitingReducers = (_ActionTypes$Response = {}, _defineProperty(_ActionTypes$Response, ActionTypes.ResponsesWaiting.Add, function (state, _ref) {
  var _ref$payload = _ref.payload,
      id = _ref$payload.id,
      action = _ref$payload.action,
      actionPayload = _ref$payload.payload;
  var newState = cloneDeep(state);
  set(newState, ['responsesWaitingQueue', id], {
    id: id,
    action: action,
    payload: actionPayload
  });
  return newState;
}), _defineProperty(_ActionTypes$Response, ActionTypes.ResponsesWaiting.Remove, function (state, _ref2) {
  var id = _ref2.payload.id;
  var newState = cloneDeep(state);
  var existingQueue = get(newState, 'responsesWaitingQueue', {});
  set(newState, 'responsesWaitingQueue', omit(existingQueue, id));
  return newState;
}), _ActionTypes$Response);

var SettingsReducers = _defineProperty({}, ActionTypes.Settings.Response, function (state, _ref) {
  var proactivity = _ref.payload.proactivity;
  return _objectSpread2({}, state, {
    proactivity: {
      enabled: get(proactivity, 'enabled', false),
      timeout: get(find(get(proactivity, 'conditions'), {
        type: 'time'
      }), 'time', 0) * 1000,
      message: get(proactivity, 'proactive_message', '')
    }
  });
});

var chatReducer = handleActions(_objectSpread2({}, AppReducers, {}, UsersReducers, {}, GroupsReducers, {}, MessageReducers, {}, RoutingReducers, {}, TalksReducers, {}, ResponsesWaitingReducers, {}, SettingsReducers), initialState);

var reducers = combineReducers({
  Chat: chatReducer
});

var namespaceSelector = function namespaceSelector(state) {
  return get(state, namespace);
};
var selectActiveUserID = createSelector(namespaceSelector, function (chat) {
  return get(chat, 'me');
});
var selectUsers = createSelector(namespaceSelector, function (chat) {
  return get(chat, 'users');
});
var selectGroups = createSelector(namespaceSelector, function (chat) {
  return get(chat, 'groups');
});
var selectOutgoingTransfers = createSelector(namespaceSelector, function (chat) {
  return get(chat, ['routing', 'outgoingTransfers']);
});
var selectOutgoingTransfer = function selectOutgoingTransfer(id) {
  return createSelector(selectOutgoingTransfers, function () {
    return id;
  }, function (transfers, roomId) {
    return find(transfers, {
      room_jid: roomId
    }) || {};
  });
};
var selectAgents = createSelector(selectActiveUserID, selectUsers, selectGroups, function (activeUser, users, groups) {
  return sortBy(map$1(filter(keys(users), function (key) {
    return key.indexOf('customer') === -1 && key !== activeUser;
  }), function (key) {
    var _users$key = users[key],
        name = _users$key.name,
        id = _users$key.id,
        meta = _users$key.meta;
    var department = map$1(get(meta, 'groups', []), function (groupId) {
      return get(groups, [groupId, 'name']);
    }).join(', ');
    return {
      name: name,
      id: id,
      department: department,
      status: get(meta, ['status', 'value'])
    };
  }), [function (agent) {
    return agent.status < 'online';
  }, function (agent) {
    return agent.name;
  }]);
});
var selectActiveUserDepartmentString = createSelector(selectActiveUserID, selectUsers, selectGroups, function (activeUser, users, groups) {
  return map$1(get(users, [activeUser, 'meta', 'groups'], []), function (groupID) {
    return groups[groupID].name;
  }).join(', ');
});
var selectUser = function selectUser(id) {
  return createSelector(selectUsers, function () {
    return id;
  }, function (users, userID) {
    return omit(get(users, userID), ['meta']);
  });
};
var selectActiveUserStatus = createSelector(namespaceSelector, selectActiveUserID, function (chat, id) {
  return get(chat, ['users', id, 'meta', 'status']);
});
var selectAppStatuses = createSelector(namespaceSelector, function (chat) {
  return get(chat, ['app', 'statuses'], {});
});
var selectProactivityConfig = createSelector(namespaceSelector, function (chat) {
  return get(chat, 'proactivity');
});
var selectRoutingStepConfig = createSelector(namespaceSelector, selectAppStatuses, selectProactivityConfig, function (chat, appStatuses, _ref) {
  var message = _ref.message;
  var isWindowOpenedOnProactivity = get(appStatuses, AppStatuses.WindowOpenedOnProactivity, false);
  var currentStepConfig = cloneDeep(get(chat, ['routing', 'currentStep', 'body']));

  if (isWindowOpenedOnProactivity) {
    set(currentStepConfig, ['payload', 'title'], message);
  }

  return currentStepConfig;
});
var selectRoutingStepPayload = createSelector(namespaceSelector, selectRoutingStepConfig, function (chat, stepConfig) {
  var form = get(stepConfig, 'payload');
  var timestamp = get(chat, ['routing', 'currentStep', 'created_at']);

  if (form && (form.type === Types.form || form.type === Types.formError || form.type === Types.schedule) && timestamp) {
    return {
      payload: {
        type: form.type,
        content: form
      },
      meta: {
        timestamp: timestamp
      }
    };
  }

  return undefined;
});
var selectRoutingFormResults = function selectRoutingFormResults(id) {
  return createSelector(namespaceSelector, function () {
    return id;
  }, function (chat, chatID) {
    return get(chat, ['routing', 'formMessages', chatID], []);
  });
};
var selectCustomerInfo = function selectCustomerInfo(id) {
  return createSelector(selectRoutingFormResults(id), function (formMessages) {
    var fields = get(formMessages[0], ['payload', 'content', 'fields'], []);
    return reduce(fields, function (acc, _ref2) {
      var key = _ref2.key,
          value = _ref2.value;
      return _objectSpread2({}, acc, _defineProperty({}, key, value));
    }, {});
  });
};
var selectMessages = function selectMessages(id) {
  return createSelector(namespaceSelector, selectRoutingStepPayload, selectRoutingFormResults(id), function () {
    return id;
  }, function (chat, routingStepPayload, formResults, chatID) {
    var messages = values(get(chat, ['messages', chatID]));
    var messagesWithFormResults = [].concat(_toConsumableArray(formResults), _toConsumableArray(messages));
    var result = routingStepPayload ? [].concat(_toConsumableArray(messagesWithFormResults), [routingStepPayload]) : messagesWithFormResults;
    return sortBy(result, function (message) {
      return get(message, ['meta', 'timestamp']);
    });
  });
};
var selectCustomerMessages = function selectCustomerMessages(id) {
  return createSelector(selectMessages(id), function (messages) {
    return filter(messages, function (message) {
      var type = get(message, ['payload', 'type'], '');
      return !/^transfer/.test(type);
    });
  });
};
var selectChats = createSelector(namespaceSelector, function (chat) {
  return get(chat, 'chats');
});
var selectChatMeta = function selectChatMeta(jid) {
  return createSelector(selectChats, function (chats) {
    return get(chats, jid);
  });
};
var selectChatsJID = createSelector(selectChats, function (chats) {
  return keys(chats);
});
var selectChatDescription = function selectChatDescription(jid) {
  return createSelector(selectChatMeta(jid), function (chat) {
    return get(chat, ['description']);
  });
};
var selectChatInputMessage = function selectChatInputMessage(jid) {
  return createSelector(selectChatMeta(jid), function (chat) {
    return get(chat, ['message']);
  });
};
var selectInvitations = createSelector(namespaceSelector, function (chat) {
  return values(get(chat, ['routing', 'invitations']));
});
var selectInvitation = function selectInvitation(id) {
  return createSelector(namespaceSelector, function () {
    return id;
  }, function (chat, uuid) {
    return get(chat, ['routing', 'invitations', uuid]);
  });
};
var selectTransferInvitations = createSelector(namespaceSelector, function (chat) {
  return values(get(chat, ['routing', 'transferInvitations']));
});
var selectTransferInvitation = function selectTransferInvitation(id) {
  return createSelector(namespaceSelector, function () {
    return id;
  }, function (chat, uuid) {
    return get(chat, ['routing', 'transferInvitations', uuid]);
  });
};

var coreInitialState = {
  Chat: initialState
};

function configureStore(reducer, epic) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var epicMiddleware = createEpicMiddleware({
    dependencies: {
      request: request,
      xmpp: xmpp
    }
  });
  var middlewares = [epicMiddleware];

  var middleware = applyMiddleware.apply(void 0, middlewares);

  var store = middleware(createStore)(reducer, merge$1(initialState, coreInitialState));
  epicMiddleware.run(epic);
  return store;
}

export { Connection, index as Constants, Event, Message, Presence, ResponsesWaiting, Roster, Settings, Status, Talks, addEventHandler, configureStore, coreInitialState, createSelector, epics as epic, getAgentAuthenticationToken, getDomain, getUtcIsoTimestamp, initEventHandler, isCustomer, namespaceSelector, parseXML, reducers as reducer, removeEventHandler, request, selectActiveUserDepartmentString, selectActiveUserID, selectActiveUserStatus, selectAgents, selectAppStatuses, selectChatDescription, selectChatInputMessage, selectChatMeta, selectChats, selectChatsJID, selectCustomerInfo, selectCustomerMessages, selectGroups, selectInvitation, selectInvitations, selectMessages, selectOutgoingTransfer, selectOutgoingTransfers, selectProactivityConfig, selectRoutingFormResults, selectRoutingStepConfig, selectRoutingStepPayload, selectTransferInvitation, selectTransferInvitations, selectUser, selectUsers, transformFormResult, transformMessage, transformScheduling, updateAppStatus, updateConnectionProps, updateGroupsInfo, updateRoutingStepData, updateUsersInfo, validateTimezone };
